// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminAppServiceGetAppData, AdminAppServiceGetAppResponses, AdminAppServiceListApiKeysData, AdminAppServiceListApiKeysResponses, AdminAppServiceListAppsData, AdminAppServiceListAppsResponses, AdminAuthServiceChangePasswordData, AdminAuthServiceChangePasswordResponses, AdminAuthServiceLoginData, AdminAuthServiceLoginResponses, AdminAvatarApplyServiceAdminDeleteAvatarApplyData, AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, AdminAvatarApplyServiceAdminListAvatarAppliesData, AdminAvatarApplyServiceAdminListAvatarAppliesResponses, AdminBillingServiceCreateCreditPackageData, AdminBillingServiceCreateCreditPackageResponses, AdminBillingServiceCreatePlanData, AdminBillingServiceCreatePlanResponses, AdminBillingServiceDeductCreditsData, AdminBillingServiceDeductCreditsResponses, AdminBillingServiceDeleteCreditPackageData, AdminBillingServiceDeleteCreditPackageResponses, AdminBillingServiceDeletePlanData, AdminBillingServiceDeletePlanResponses, AdminBillingServiceGetBillingStatsData, AdminBillingServiceGetBillingStatsResponses, AdminBillingServiceGetPlanData, AdminBillingServiceGetPlanResponses, AdminBillingServiceGetUserCreditBalanceData, AdminBillingServiceGetUserCreditBalanceResponses, AdminBillingServiceGetUserSubscriptionData, AdminBillingServiceGetUserSubscriptionResponses, AdminBillingServiceGrantCreditsData, AdminBillingServiceGrantCreditsResponses, AdminBillingServiceListCreditPackagesData, AdminBillingServiceListCreditPackagesResponses, AdminBillingServiceListPlansData, AdminBillingServiceListPlansResponses, AdminBillingServiceListSubscriptionsData, AdminBillingServiceListSubscriptionsResponses, AdminBillingServiceListUserCreditTransactionsData, AdminBillingServiceListUserCreditTransactionsResponses, AdminBillingServiceListUserCreditUsagesData, AdminBillingServiceListUserCreditUsagesResponses, AdminBillingServiceUpdateCreditPackageData, AdminBillingServiceUpdateCreditPackageResponses, AdminBillingServiceUpdatePlanData, AdminBillingServiceUpdatePlanResponses, AdminBillingServiceUpdateUserSubscriptionData, AdminBillingServiceUpdateUserSubscriptionResponses, AdminConfigServiceAdminCreateConfigData, AdminConfigServiceAdminCreateConfigResponses, AdminConfigServiceAdminCreateUserConfigData, AdminConfigServiceAdminCreateUserConfigResponses, AdminConfigServiceAdminDeleteConfigData, AdminConfigServiceAdminDeleteConfigResponses, AdminConfigServiceAdminGetConfigData, AdminConfigServiceAdminGetConfigResponses, AdminConfigServiceAdminGetUserConfigData, AdminConfigServiceAdminGetUserConfigResponses, AdminConfigServiceAdminListConfigsData, AdminConfigServiceAdminListConfigsResponses, AdminConfigServiceAdminListUserConfigsData, AdminConfigServiceAdminListUserConfigsResponses, AdminConfigServiceAdminUpdateConfigData, AdminConfigServiceAdminUpdateConfigResponses, AdminConfigServiceAdminUpdateUserConfigData, AdminConfigServiceAdminUpdateUserConfigResponses, AdminDrivenStatsServiceGetConcurrencyTrendData, AdminDrivenStatsServiceGetConcurrencyTrendResponses, AdminDrivenStatsServiceGetEntityStatsData, AdminDrivenStatsServiceGetEntityStatsResponses, AdminDrivenStatsServiceGetOverviewData, AdminDrivenStatsServiceGetOverviewResponses, AdminDrivenStatsServiceGetRealtimeStatsData, AdminDrivenStatsServiceGetRealtimeStatsResponses, AdminDrivenStatsServiceGetRegionDistributionData, AdminDrivenStatsServiceGetRegionDistributionResponses, AdminDrivenStatsServiceGetTopAppsData, AdminDrivenStatsServiceGetTopAppsResponses, AdminDrivenStatsServiceGetTopUsersData, AdminDrivenStatsServiceGetTopUsersResponses, AdminDrivenStatsServiceGetTrendData, AdminDrivenStatsServiceGetTrendResponses, AdminPublicAvatarServiceAdminCreatePublicAvatarData, AdminPublicAvatarServiceAdminCreatePublicAvatarResponses, AdminPublicAvatarServiceAdminDeletePublicAvatarData, AdminPublicAvatarServiceAdminDeletePublicAvatarResponses, AdminPublicAvatarServiceAdminListPublicAvatarsData, AdminPublicAvatarServiceAdminListPublicAvatarsResponses, AdminPublicAvatarServiceAdminUpdatePublicAvatarData, AdminPublicAvatarServiceAdminUpdatePublicAvatarResponses, AdminUserCharacterServiceAdminCreateUserCharacterData, AdminUserCharacterServiceAdminCreateUserCharacterResponses, AdminUserCharacterServiceAdminDeleteUserCharacterData, AdminUserCharacterServiceAdminDeleteUserCharacterResponses, AdminUserCharacterServiceAdminGetUserCharacterData, AdminUserCharacterServiceAdminGetUserCharacterResponses, AdminUserCharacterServiceAdminListUserCharactersData, AdminUserCharacterServiceAdminListUserCharactersResponses, AdminUserCharacterServiceAdminUpdateUserCharacterData, AdminUserCharacterServiceAdminUpdateUserCharacterResponses, AdminUserServiceCreateAdminUserData, AdminUserServiceCreateAdminUserResponses, AdminUserServiceDeleteAdminUserData, AdminUserServiceDeleteAdminUserResponses, AdminUserServiceListAdminUsersData, AdminUserServiceListAdminUsersResponses, AdminUserServiceListUsersData, AdminUserServiceListUsersResponses, AdminUserServiceUpdateUserRemarkData, AdminUserServiceUpdateUserRemarkResponses, AppServiceCreateApiKeyData, AppServiceCreateApiKeyResponses, AppServiceDeleteApiKeyData, AppServiceDeleteApiKeyResponses, AppServiceDeleteAppData, AppServiceDeleteAppResponses, AppServiceGetAppData, AppServiceGetAppResponses, AppServiceListApiKeysData, AppServiceListApiKeysResponses, AssetGroupServiceCreateAssetGroupData, AssetGroupServiceCreateAssetGroupResponses, AssetGroupServiceDeleteAssetGroupData, AssetGroupServiceDeleteAssetGroupResponses, AssetGroupServiceGetAssetGroupData, AssetGroupServiceGetAssetGroupResponses, AssetGroupServiceListAssetGroupsData, AssetGroupServiceListAssetGroupsResponses, AssetGroupServiceSyncAssetGroupData, AssetGroupServiceSyncAssetGroupResponses, AssetGroupServiceUpdateAssetGroupData, AssetGroupServiceUpdateAssetGroupResponses, AssetServiceCreateAssetData, AssetServiceCreateAssetResponses, AssetServiceDeleteAssetData, AssetServiceDeleteAssetResponses, AssetServiceGetAssetData, AssetServiceGetAssetResponses, AssetServiceListAssetsData, AssetServiceListAssetsResponses, AssetServiceUpdateAssetData, AssetServiceUpdateAssetResponses, AsyncProcessingServiceAdjustMaterialAsyncData, AsyncProcessingServiceAdjustMaterialAsyncResponses, AsyncProcessingServiceCreateTaskAsyncData, AsyncProcessingServiceCreateTaskAsyncResponses, AuthServiceChangePasswordData, AuthServiceChangePasswordResponses, AuthServiceLoginData, AuthServiceLoginResponses, AuthServiceLogoutData, AuthServiceLogoutResponses, AuthServiceMeData, AuthServiceMeResponses, AuthServiceOAuthLoginData, AuthServiceOAuthLoginResponses, AuthServiceRegisterData, AuthServiceRegisterResponses, AuthServiceResetPasswordData, AuthServiceResetPasswordResponses, AuthServiceSendVerificationCodeData, AuthServiceSendVerificationCodeResponses, AuthServiceUpdateProfileData, AuthServiceUpdateProfileResponses, AuthServiceVerifyVerificationCodeData, AuthServiceVerifyVerificationCodeResponses, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, AvatarServiceCopyAvatarData, AvatarServiceCopyAvatarResponses, AvatarServiceCreateAvatarData, AvatarServiceCreateAvatarResponses, AvatarServiceDeleteAvatarApplyData, AvatarServiceDeleteAvatarApplyResponses, AvatarServiceDeleteAvatarData, AvatarServiceDeleteAvatarResponses, AvatarServiceGetAvatarDetailData, AvatarServiceGetAvatarDetailResponses, AvatarServiceListAvatarAppliesData, AvatarServiceListAvatarAppliesResponses, AvatarServiceListAvatarsData, AvatarServiceListAvatarsResponses, AvatarServiceListDrivenProvidersData, AvatarServiceListDrivenProvidersResponses, AvatarServiceListKlingMotionPresetsData, AvatarServiceListKlingMotionPresetsResponses, AvatarServiceUpdateAvatarData, AvatarServiceUpdateAvatarResponses, BillingServiceCancelSubscriptionData, BillingServiceCancelSubscriptionResponses, BillingServiceCheckSessionPermissionData, BillingServiceCheckSessionPermissionResponses, BillingServiceCreateSubscriptionData, BillingServiceCreateSubscriptionResponses, BillingServiceDowngradeSubscriptionData, BillingServiceDowngradeSubscriptionResponses, BillingServiceGetAutoReloadConfigData, BillingServiceGetAutoReloadConfigResponses, BillingServiceGetCreditBalanceData, BillingServiceGetCreditBalanceResponses, BillingServiceGetCustomerPortalData, BillingServiceGetCustomerPortalResponses, BillingServiceGetSubscriptionData, BillingServiceGetSubscriptionResponses, BillingServiceGetUsageSummaryData, BillingServiceGetUsageSummaryResponses, BillingServiceListCreditPackagesData, BillingServiceListCreditPackagesResponses, BillingServiceListCreditTransactionsData, BillingServiceListCreditTransactionsResponses, BillingServiceListPlansData, BillingServiceListPlansResponses, BillingServicePurchaseCreditPackageData, BillingServicePurchaseCreditPackageResponses, BillingServiceResumeSubscriptionData, BillingServiceResumeSubscriptionResponses, BillingServiceSetupAutoReloadPaymentMethodData, BillingServiceSetupAutoReloadPaymentMethodResponses, BillingServiceUpdateAutoReloadConfigData, BillingServiceUpdateAutoReloadConfigResponses, BillingServiceUpgradeSubscriptionData, BillingServiceUpgradeSubscriptionResponses, CharacterServiceCopyCharacterData, CharacterServiceCopyCharacterResponses, CharacterServiceCreateCharacterData, CharacterServiceCreateCharacterResponses, CharacterServiceDeleteCharacterData, CharacterServiceDeleteCharacterResponses, CharacterServiceGetCharacterData, CharacterServiceGetCharacterLiteData, CharacterServiceGetCharacterLiteResponses, CharacterServiceGetCharacterResponses, CharacterServiceListCharacterListsData, CharacterServiceListCharacterListsResponses, CharacterServiceListCharactersData, CharacterServiceListCharactersResponses, CharacterServiceProcessCoefData, CharacterServiceProcessCoefResponses, CharacterServiceSetCharacterListsData, CharacterServiceSetCharacterListsResponses, CharacterServiceSyncCharacterData, CharacterServiceSyncCharacterResponses, CharacterServiceUpdateCharacterData, CharacterServiceUpdateCharacterResponses, CharacterTemplateServiceCreateCharacterTemplateData, CharacterTemplateServiceCreateCharacterTemplateResponses, CharacterTemplateServiceDeleteCharacterTemplateData, CharacterTemplateServiceDeleteCharacterTemplateResponses, CharacterTemplateServiceGetCharacterTemplateData, CharacterTemplateServiceGetCharacterTemplateResponses, CharacterTemplateServiceListCharacterTemplatesData, CharacterTemplateServiceListCharacterTemplatesResponses, CharacterTemplateServiceUpdateCharacterTemplateData, CharacterTemplateServiceUpdateCharacterTemplateResponses, CliAuthServiceApproveCliAuthSessionData, CliAuthServiceApproveCliAuthSessionResponses, CliAuthServiceCreateCliAuthSessionData, CliAuthServiceCreateCliAuthSessionResponses, CliAuthServiceExchangeCliAuthTokenData, CliAuthServiceExchangeCliAuthTokenResponses, CliAuthServiceGetCliAuthSessionData, CliAuthServiceGetCliAuthSessionResponses, CliAuthServiceRefreshCliAuthTokenData, CliAuthServiceRefreshCliAuthTokenResponses, CliAuthServiceRevokeCliAuthTokenData, CliAuthServiceRevokeCliAuthTokenResponses, CollectionTaskServiceCreateCollectionTask2Data, CollectionTaskServiceCreateCollectionTask2Responses, CollectionTaskServiceCreateCollectionTaskData, CollectionTaskServiceCreateCollectionTaskResponses, CollectionTaskServiceDeleteCollectionTask2Data, CollectionTaskServiceDeleteCollectionTask2Responses, CollectionTaskServiceDeleteCollectionTaskData, CollectionTaskServiceDeleteCollectionTaskResponses, CollectionTaskServiceGetCollectionTask2Data, CollectionTaskServiceGetCollectionTask2Responses, CollectionTaskServiceGetCollectionTaskByToken2Data, CollectionTaskServiceGetCollectionTaskByToken2Responses, CollectionTaskServiceGetCollectionTaskByTokenData, CollectionTaskServiceGetCollectionTaskByTokenResponses, CollectionTaskServiceGetCollectionTaskData, CollectionTaskServiceGetCollectionTaskOssCredentials2Data, CollectionTaskServiceGetCollectionTaskOssCredentials2Responses, CollectionTaskServiceGetCollectionTaskOssCredentialsData, CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, CollectionTaskServiceGetCollectionTaskResponses, CollectionTaskServiceListCollectionTasks2Data, CollectionTaskServiceListCollectionTasks2Responses, CollectionTaskServiceListCollectionTasksData, CollectionTaskServiceListCollectionTasksResponses, CollectionTaskServiceSubmitCollectionFile2Data, CollectionTaskServiceSubmitCollectionFile2Responses, CollectionTaskServiceSubmitCollectionFileData, CollectionTaskServiceSubmitCollectionFileResponses, CollectionTaskServiceUpdateCollectionTask2Data, CollectionTaskServiceUpdateCollectionTask2Responses, CollectionTaskServiceUpdateCollectionTaskData, CollectionTaskServiceUpdateCollectionTaskResponses, CollectiveEvaluationServiceCreateCollectiveEvaluationData, CollectiveEvaluationServiceCreateCollectiveEvaluationResponses, CollectiveEvaluationServiceGetCollectiveEvaluationData, CollectiveEvaluationServiceGetCollectiveEvaluationResponses, CollectiveEvaluationServiceListCollectiveEvaluationGroupVotesData, CollectiveEvaluationServiceListCollectiveEvaluationGroupVotesResponses, CollectiveEvaluationServiceSubmitCollectiveEvaluationVoteData, CollectiveEvaluationServiceSubmitCollectiveEvaluationVoteResponses, CommonServiceGetR2PresignedPutUrlData, CommonServiceGetR2PresignedPutUrlResponses, ConfigKvServiceCreateConfigKvData, ConfigKvServiceCreateConfigKvResponses, ConfigKvServiceDeleteConfigKvData, ConfigKvServiceDeleteConfigKvResponses, ConfigKvServiceGetConfigKvData, ConfigKvServiceGetConfigKvResponses, ConfigKvServiceListConfigKvsData, ConfigKvServiceListConfigKvsResponses, ConfigKvServiceUpdateConfigKvData, ConfigKvServiceUpdateConfigKvResponses, ConsoleServiceCreateApiKeyData, ConsoleServiceCreateApiKeyResponses, ConsoleServiceCreateAppData, ConsoleServiceCreateAppResponses, ConsoleServiceCreateSessionTokenData, ConsoleServiceCreateSessionTokenResponses, ConsoleServiceDeleteAppData, ConsoleServiceDeleteAppKeyData, ConsoleServiceDeleteAppKeyResponses, ConsoleServiceDeleteAppResponses, ConsoleServiceGetAppData, ConsoleServiceGetAppResponses, ConsoleServiceGetOssCredentialsData, ConsoleServiceGetOssCredentialsResponses, ConsoleServiceListAppsData, ConsoleServiceListAppsResponses, DrivenIngressServiceGetCharacterInfoData, DrivenIngressServiceGetCharacterInfoResponses, DrivenStatsServiceGetAllRegionsStatsData, DrivenStatsServiceGetAllRegionsStatsResponses, DrivenStatsServiceGetRegionStatsData, DrivenStatsServiceGetRegionStatsResponses, DrivenStatsServiceSyncDrivenStatsData, DrivenStatsServiceSyncDrivenStatsResponses, FeedbackTicketServiceAdminCreateFeedbackReplyData, FeedbackTicketServiceAdminCreateFeedbackReplyResponses, FeedbackTicketServiceAdminCreateFeedbackTicketData, FeedbackTicketServiceAdminCreateFeedbackTicketResponses, FeedbackTicketServiceAdminGetFeedbackTicketData, FeedbackTicketServiceAdminGetFeedbackTicketResponses, FeedbackTicketServiceAdminListFeedbackTicketsData, FeedbackTicketServiceAdminListFeedbackTicketsResponses, FeedbackTicketServiceAdminUpdateTicketStatusData, FeedbackTicketServiceAdminUpdateTicketStatusResponses, FeedbackTicketServiceCloseFeedbackTicketData, FeedbackTicketServiceCloseFeedbackTicketResponses, FeedbackTicketServiceCreateFeedbackReplyData, FeedbackTicketServiceCreateFeedbackReplyResponses, FeedbackTicketServiceCreateFeedbackTicketData, FeedbackTicketServiceCreateFeedbackTicketResponses, FeedbackTicketServiceGetFeedbackTicketData, FeedbackTicketServiceGetFeedbackTicketResponses, FeedbackTicketServiceListMyFeedbackTicketsData, FeedbackTicketServiceListMyFeedbackTicketsResponses, FeedbackTicketServiceUpdateFeedbackTicketData, FeedbackTicketServiceUpdateFeedbackTicketResponses, GpuTaskCallbackServiceReportHeartbeatData, GpuTaskCallbackServiceReportHeartbeatResponses, GpuTaskCallbackServiceUploadResultsData, GpuTaskCallbackServiceUploadResultsResponses, GpuTaskServiceCancelGpuTaskData, GpuTaskServiceCancelGpuTaskResponses, GpuTaskServiceCreateGpuTaskData, GpuTaskServiceCreateGpuTaskResponses, GpuTaskServiceGetGpuTaskData, GpuTaskServiceGetGpuTaskLogsData, GpuTaskServiceGetGpuTaskLogsResponses, GpuTaskServiceGetGpuTaskResponses, GpuTaskServiceGetGpuTaskStatsData, GpuTaskServiceGetGpuTaskStatsResponses, GpuTaskServiceListGpuTasksData, GpuTaskServiceListGpuTasksResponses, GpuTaskServiceListOssVideosData, GpuTaskServiceListOssVideosResponses, GpuTaskServiceRetryGpuTaskData, GpuTaskServiceRetryGpuTaskResponses, InstanceManagementServiceListContainerImages2Data, InstanceManagementServiceListContainerImages2Responses, InstanceManagementServiceListContainerImagesData, InstanceManagementServiceListContainerImagesResponses, InstanceManagementServiceListContainerImageTags2Data, InstanceManagementServiceListContainerImageTags2Responses, InstanceManagementServiceListContainerImageTagsData, InstanceManagementServiceListContainerImageTagsResponses, InstanceManagementServiceListInstances2Data, InstanceManagementServiceListInstances2Responses, InstanceManagementServiceListInstancesData, InstanceManagementServiceListInstancesResponses, InstanceManagementServiceListLaunchTemplates2Data, InstanceManagementServiceListLaunchTemplates2Responses, InstanceManagementServiceListLaunchTemplatesData, InstanceManagementServiceListLaunchTemplatesResponses, JoiAvatarServiceDeleteJoiAvatarData, JoiAvatarServiceDeleteJoiAvatarResponses, JoiAvatarServiceListJoiAvatarsData, JoiAvatarServiceListJoiAvatarsResponses, JoiModelApplyServiceGetJoiModelApplyStatsData, JoiModelApplyServiceGetJoiModelApplyStatsResponses, JoiModelApplyServiceListJoiModelAppliesData, JoiModelApplyServiceListJoiModelAppliesResponses, JoiTaskCallbackServiceListJoiTaskCallbacksData, JoiTaskCallbackServiceListJoiTaskCallbacksResponses, MaterialServiceAdjustMaterial2Data, MaterialServiceAdjustMaterial2Responses, MaterialServiceAdjustMaterialData, MaterialServiceAdjustMaterialResponses, MaterialServiceCreateMaterial2Data, MaterialServiceCreateMaterial2Responses, MaterialServiceCreateMaterialData, MaterialServiceCreateMaterialResponses, MaterialServiceDeleteMaterial2Data, MaterialServiceDeleteMaterial2Responses, MaterialServiceDeleteMaterialData, MaterialServiceDeleteMaterialResponses, MaterialServiceGetMaterial2Data, MaterialServiceGetMaterial2Responses, MaterialServiceGetMaterialData, MaterialServiceGetMaterialResponses, MaterialServiceListMaterials2Data, MaterialServiceListMaterials2Responses, MaterialServiceListMaterialsData, MaterialServiceListMaterialsResponses, MaterialServiceUpdateMaterial2Data, MaterialServiceUpdateMaterial2Responses, MaterialServiceUpdateMaterialData, MaterialServiceUpdateMaterialResponses, OssServiceGetOssCredentialsData, OssServiceGetOssCredentialsResponses, PipeTemplateServiceCreatePipeTemplate2Data, PipeTemplateServiceCreatePipeTemplate2Responses, PipeTemplateServiceCreatePipeTemplateData, PipeTemplateServiceCreatePipeTemplateResponses, PipeTemplateServiceDeletePipeTemplate2Data, PipeTemplateServiceDeletePipeTemplate2Responses, PipeTemplateServiceDeletePipeTemplateData, PipeTemplateServiceDeletePipeTemplateResponses, PipeTemplateServiceGetPipeTemplate2Data, PipeTemplateServiceGetPipeTemplate2Responses, PipeTemplateServiceGetPipeTemplateData, PipeTemplateServiceGetPipeTemplateResponses, PipeTemplateServiceListPipeTemplates2Data, PipeTemplateServiceListPipeTemplates2Responses, PipeTemplateServiceListPipeTemplatesData, PipeTemplateServiceListPipeTemplatesResponses, PipeTemplateServiceListTrackerVersions2Data, PipeTemplateServiceListTrackerVersions2Responses, PipeTemplateServiceListTrackerVersionsData, PipeTemplateServiceListTrackerVersionsResponses, PipeTemplateServiceUpdatePipeTemplate2Data, PipeTemplateServiceUpdatePipeTemplate2Responses, PipeTemplateServiceUpdatePipeTemplateData, PipeTemplateServiceUpdatePipeTemplateResponses, PreprocessServiceCropImageData, PreprocessServiceCropImageResponses, PreprocessServicePoseAdjustData, PreprocessServicePoseAdjustResponses, ProviderServiceCreateProviderData, ProviderServiceCreateProviderResponses, ProviderServiceDeleteProviderData, ProviderServiceDeleteProviderResponses, ProviderServiceGetProviderData, ProviderServiceGetProviderResponses, ProviderServiceListProvidersData, ProviderServiceListProvidersResponses, ProviderServiceUpdateProviderData, ProviderServiceUpdateProviderResponses, PublicAvatarServiceListPublicAvatarsData, PublicAvatarServiceListPublicAvatarsResponses, ReconModelServiceCreateReconModelData, ReconModelServiceCreateReconModelResponses, ReconModelServiceDeleteReconModelData, ReconModelServiceDeleteReconModelResponses, ReconModelServiceGetReconModelData, ReconModelServiceGetReconModelResponses, ReconModelServiceListReconModelsData, ReconModelServiceListReconModelsResponses, ReconModelServiceUpdateReconModelData, ReconModelServiceUpdateReconModelResponses, ReconTaskServiceCancelReconTaskData, ReconTaskServiceCancelReconTaskResponses, ReconTaskServiceCreateReconTaskData, ReconTaskServiceCreateReconTaskResponses, ReconTaskServiceGetReconTaskData, ReconTaskServiceGetReconTaskResponses, ReconTaskServiceListReconTasksData, ReconTaskServiceListReconTasksResponses, ReconTaskServiceRetryReconTaskData, ReconTaskServiceRetryReconTaskResponses, RedeemServiceCreateRedeemData, RedeemServiceCreateRedeemResponses, RedeemServiceGetRedeemData, RedeemServiceGetRedeemResponses, RedeemServiceListRedeemsData, RedeemServiceListRedeemsResponses, RedeemServiceUpdateRedeemData, RedeemServiceUpdateRedeemResponses, SmsSendLogServiceListSmsSendLogsData, SmsSendLogServiceListSmsSendLogsResponses, TaskHeartbeatServiceHeartbeatData, TaskHeartbeatServiceHeartbeatResponses, TaskServiceBatchCreateTasksData, TaskServiceBatchCreateTasksResponses, TaskServiceCreateStatus2Data, TaskServiceCreateStatus2Responses, TaskServiceCreateStatusData, TaskServiceCreateStatusResponses, TaskServiceCreateTask2Data, TaskServiceCreateTask2Responses, TaskServiceCreateTaskData, TaskServiceCreateTaskResponses, TaskServiceDeleteStatus2Data, TaskServiceDeleteStatus2Responses, TaskServiceDeleteStatusData, TaskServiceDeleteStatusResponses, TaskServiceDeleteTask2Data, TaskServiceDeleteTask2Responses, TaskServiceDeleteTaskData, TaskServiceDeleteTaskResponses, TaskServiceGetStatus2Data, TaskServiceGetStatus2Responses, TaskServiceGetStatusData, TaskServiceGetStatusResponses, TaskServiceGetTask2Data, TaskServiceGetTask2Responses, TaskServiceGetTaskData, TaskServiceGetTaskResponses, TaskServiceGetTaskStats2Data, TaskServiceGetTaskStats2Responses, TaskServiceGetTaskStatsData, TaskServiceGetTaskStatsResponses, TaskServiceListStatuses2Data, TaskServiceListStatuses2Responses, TaskServiceListStatusesData, TaskServiceListStatusesResponses, TaskServiceListTasks2Data, TaskServiceListTasks2Responses, TaskServiceListTasksData, TaskServiceListTasksResponses, TaskServiceTerminateTaskInstances2Data, TaskServiceTerminateTaskInstances2Responses, TaskServiceTerminateTaskInstancesData, TaskServiceTerminateTaskInstancesResponses, TaskServiceUpdateStatus2Data, TaskServiceUpdateStatus2Responses, TaskServiceUpdateStatusData, TaskServiceUpdateStatusResponses, TaskServiceUpdateTask2Data, TaskServiceUpdateTask2Responses, TaskServiceUpdateTaskData, TaskServiceUpdateTaskResponses, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, UserDrivenStatsServiceGetSessionCountData, UserDrivenStatsServiceGetSessionCountResponses, UserDrivenStatsServiceGetUsageData, UserDrivenStatsServiceGetUsageResponses, UserDrivenStatsServiceListConnectionLogsData, UserDrivenStatsServiceListConnectionLogsResponses, UserServiceCreateUserData, UserServiceCreateUserResponses, UserServiceDeleteUserData, UserServiceDeleteUserResponses, UserServiceGetUserData, UserServiceGetUserResponses, UserServiceListUsersData, UserServiceListUsersResponses, UserServiceUpdateUserData, UserServiceUpdateUserResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List connection logs for the authenticated user
 */
export const userDrivenStatsServiceListConnectionLogs = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceListConnectionLogsData, ThrowOnError>) => (options?.client ?? client).get<UserDrivenStatsServiceListConnectionLogsResponses, unknown, ThrowOnError>({ url: '/api/console/v2/stats/connection-logs', ...options });

/**
 * Get realtime concurrent connections for the authenticated user
 */
export const userDrivenStatsServiceGetRealtimeConcurrentConnections = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, ThrowOnError>) => (options?.client ?? client).get<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, unknown, ThrowOnError>({ url: '/api/console/v2/stats/realtime-connections', ...options });

/**
 * Get session count time series for the authenticated user
 */
export const userDrivenStatsServiceGetSessionCount = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetSessionCountData, ThrowOnError>) => (options?.client ?? client).get<UserDrivenStatsServiceGetSessionCountResponses, unknown, ThrowOnError>({ url: '/api/console/v2/stats/session-count', ...options });

/**
 * Get audio usage time series for the authenticated user
 */
export const userDrivenStatsServiceGetUsage = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetUsageData, ThrowOnError>) => (options?.client ?? client).get<UserDrivenStatsServiceGetUsageResponses, unknown, ThrowOnError>({ url: '/api/console/v2/stats/usage', ...options });

/**
 * Admin-facing
 */
export const feedbackTicketServiceAdminListFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceAdminListFeedbackTicketsData, ThrowOnError>) => (options?.client ?? client).get<FeedbackTicketServiceAdminListFeedbackTicketsResponses, unknown, ThrowOnError>({ url: '/api/v1/admin/feedback/tickets', ...options });

export const feedbackTicketServiceAdminCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackTicketData, ThrowOnError>) => (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackTicketResponses, unknown, ThrowOnError>({
    url: '/api/v1/admin/feedback/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const feedbackTicketServiceAdminGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminGetFeedbackTicketData, ThrowOnError>) => (options.client ?? client).get<FeedbackTicketServiceAdminGetFeedbackTicketResponses, unknown, ThrowOnError>({ url: '/api/v1/admin/feedback/tickets/{id}', ...options });

export const feedbackTicketServiceAdminUpdateTicketStatus = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminUpdateTicketStatusData, ThrowOnError>) => (options.client ?? client).patch<FeedbackTicketServiceAdminUpdateTicketStatusResponses, unknown, ThrowOnError>({
    url: '/api/v1/admin/feedback/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const feedbackTicketServiceAdminCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackReplyData, ThrowOnError>) => (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackReplyResponses, unknown, ThrowOnError>({
    url: '/api/v1/admin/feedback/tickets/{ticketId}/replies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const feedbackTicketServiceListMyFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceListMyFeedbackTicketsData, ThrowOnError>) => (options?.client ?? client).get<FeedbackTicketServiceListMyFeedbackTicketsResponses, unknown, ThrowOnError>({ url: '/api/v1/feedback/tickets', ...options });

/**
 * User-facing
 */
export const feedbackTicketServiceCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackTicketData, ThrowOnError>) => (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackTicketResponses, unknown, ThrowOnError>({
    url: '/api/v1/feedback/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const feedbackTicketServiceGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceGetFeedbackTicketData, ThrowOnError>) => (options.client ?? client).get<FeedbackTicketServiceGetFeedbackTicketResponses, unknown, ThrowOnError>({ url: '/api/v1/feedback/tickets/{id}', ...options });

export const feedbackTicketServiceUpdateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceUpdateFeedbackTicketData, ThrowOnError>) => (options.client ?? client).patch<FeedbackTicketServiceUpdateFeedbackTicketResponses, unknown, ThrowOnError>({
    url: '/api/v1/feedback/tickets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const feedbackTicketServiceCloseFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCloseFeedbackTicketData, ThrowOnError>) => (options.client ?? client).post<FeedbackTicketServiceCloseFeedbackTicketResponses, unknown, ThrowOnError>({ url: '/api/v1/feedback/tickets/{id}/close', ...options });

export const feedbackTicketServiceCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackReplyData, ThrowOnError>) => (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackReplyResponses, unknown, ThrowOnError>({
    url: '/api/v1/feedback/tickets/{ticketId}/replies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all admin users
 */
export const adminUserServiceListAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListAdminUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminUserServiceListAdminUsersResponses, unknown, ThrowOnError>({ url: '/v1/admin/admin-users', ...options });

/**
 * Create a new admin user
 */
export const adminUserServiceCreateAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceCreateAdminUserData, ThrowOnError>) => (options.client ?? client).post<AdminUserServiceCreateAdminUserResponses, unknown, ThrowOnError>({
    url: '/v1/admin/admin-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an admin user
 */
export const adminUserServiceDeleteAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceDeleteAdminUserData, ThrowOnError>) => (options.client ?? client).delete<AdminUserServiceDeleteAdminUserResponses, unknown, ThrowOnError>({ url: '/v1/admin/admin-users/{adminUserId}', ...options });

/**
 * List all API keys with optional app_id and user_id filters
 */
export const adminAppServiceListApiKeys = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListApiKeysData, ThrowOnError>) => (options?.client ?? client).get<AdminAppServiceListApiKeysResponses, unknown, ThrowOnError>({ url: '/v1/admin/api-keys', ...options });

/**
 * List all applications with optional user ID filter
 */
export const adminAppServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListAppsData, ThrowOnError>) => (options?.client ?? client).get<AdminAppServiceListAppsResponses, unknown, ThrowOnError>({ url: '/v1/admin/apps', ...options });

/**
 * Get application detail by app_id
 */
export const adminAppServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AdminAppServiceGetAppData, ThrowOnError>) => (options.client ?? client).get<AdminAppServiceGetAppResponses, unknown, ThrowOnError>({ url: '/v1/admin/apps/{appId}', ...options });

/**
 * Change password
 */
export const adminAuthServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceChangePasswordData, ThrowOnError>) => (options.client ?? client).post<AdminAuthServiceChangePasswordResponses, unknown, ThrowOnError>({
    url: '/v1/admin/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login with email and password
 */
export const adminAuthServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceLoginData, ThrowOnError>) => (options.client ?? client).post<AdminAuthServiceLoginResponses, unknown, ThrowOnError>({
    url: '/v1/admin/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all console configs
 */
export const adminConfigServiceAdminListConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListConfigsData, ThrowOnError>) => (options?.client ?? client).get<AdminConfigServiceAdminListConfigsResponses, unknown, ThrowOnError>({ url: '/v1/admin/configs', ...options });

/**
 * Create a new console config
 */
export const adminConfigServiceAdminCreateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateConfigData, ThrowOnError>) => (options.client ?? client).post<AdminConfigServiceAdminCreateConfigResponses, unknown, ThrowOnError>({
    url: '/v1/admin/configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a console config
 */
export const adminConfigServiceAdminDeleteConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminDeleteConfigData, ThrowOnError>) => (options.client ?? client).delete<AdminConfigServiceAdminDeleteConfigResponses, unknown, ThrowOnError>({ url: '/v1/admin/configs/{key}', ...options });

/**
 * Get console config by key
 */
export const adminConfigServiceAdminGetConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetConfigData, ThrowOnError>) => (options.client ?? client).get<AdminConfigServiceAdminGetConfigResponses, unknown, ThrowOnError>({ url: '/v1/admin/configs/{key}', ...options });

/**
 * Update an existing console config
 */
export const adminConfigServiceAdminUpdateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateConfigData, ThrowOnError>) => (options.client ?? client).put<AdminConfigServiceAdminUpdateConfigResponses, unknown, ThrowOnError>({
    url: '/v1/admin/configs/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetAllRegionsStats returns aggregated real-time stats from all regions
 * Only available on the primary Console (SV), aggregates data from BJ, TYO, SV
 */
export const drivenStatsServiceGetAllRegionsStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetAllRegionsStatsData, ThrowOnError>) => (options?.client ?? client).get<DrivenStatsServiceGetAllRegionsStatsResponses, unknown, ThrowOnError>({ url: '/v1/admin/driven-stats/all-regions', ...options });

/**
 * List all console user characters with optional filters
 */
export const adminUserCharacterServiceAdminListUserCharacters = <ThrowOnError extends boolean = false>(options?: Options<AdminUserCharacterServiceAdminListUserCharactersData, ThrowOnError>) => (options?.client ?? client).get<AdminUserCharacterServiceAdminListUserCharactersResponses, unknown, ThrowOnError>({ url: '/v1/admin/user-characters', ...options });

/**
 * Create a new console user character
 */
export const adminUserCharacterServiceAdminCreateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminCreateUserCharacterData, ThrowOnError>) => (options.client ?? client).post<AdminUserCharacterServiceAdminCreateUserCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/admin/user-characters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a console user character
 */
export const adminUserCharacterServiceAdminDeleteUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminDeleteUserCharacterData, ThrowOnError>) => (options.client ?? client).delete<AdminUserCharacterServiceAdminDeleteUserCharacterResponses, unknown, ThrowOnError>({ url: '/v1/admin/user-characters/{id}', ...options });

/**
 * Get console user character by ID
 */
export const adminUserCharacterServiceAdminGetUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminGetUserCharacterData, ThrowOnError>) => (options.client ?? client).get<AdminUserCharacterServiceAdminGetUserCharacterResponses, unknown, ThrowOnError>({ url: '/v1/admin/user-characters/{id}', ...options });

/**
 * Update an existing console user character
 */
export const adminUserCharacterServiceAdminUpdateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminUpdateUserCharacterData, ThrowOnError>) => (options.client ?? client).put<AdminUserCharacterServiceAdminUpdateUserCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/admin/user-characters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all console user configs with optional user_id filter
 */
export const adminConfigServiceAdminListUserConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListUserConfigsData, ThrowOnError>) => (options?.client ?? client).get<AdminConfigServiceAdminListUserConfigsResponses, unknown, ThrowOnError>({ url: '/v1/admin/user-configs', ...options });

/**
 * Create a new console user config
 */
export const adminConfigServiceAdminCreateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateUserConfigData, ThrowOnError>) => (options.client ?? client).post<AdminConfigServiceAdminCreateUserConfigResponses, unknown, ThrowOnError>({
    url: '/v1/admin/user-configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get console user config by user_id
 */
export const adminConfigServiceAdminGetUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetUserConfigData, ThrowOnError>) => (options.client ?? client).get<AdminConfigServiceAdminGetUserConfigResponses, unknown, ThrowOnError>({ url: '/v1/admin/user-configs/{userId}', ...options });

/**
 * Update console user config
 */
export const adminConfigServiceAdminUpdateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateUserConfigData, ThrowOnError>) => (options.client ?? client).put<AdminConfigServiceAdminUpdateUserConfigResponses, unknown, ThrowOnError>({
    url: '/v1/admin/user-configs/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all console users
 */
export const adminUserServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminUserServiceListUsersResponses, unknown, ThrowOnError>({ url: '/v1/admin/users', ...options });

/**
 * Update remark for a console user
 */
export const adminUserServiceUpdateUserRemark = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceUpdateUserRemarkData, ThrowOnError>) => (options.client ?? client).put<AdminUserServiceUpdateUserRemarkResponses, unknown, ThrowOnError>({
    url: '/v1/admin/users/{userId}/remark',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const consoleServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<ConsoleServiceListAppsData, ThrowOnError>) => (options?.client ?? client).get<ConsoleServiceListAppsResponses, unknown, ThrowOnError>({ url: '/v1/apps', ...options });

export const consoleServiceCreateApp = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceCreateAppData, ThrowOnError>) => (options.client ?? client).post<ConsoleServiceCreateAppResponses, unknown, ThrowOnError>({
    url: '/v1/apps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const consoleServiceDeleteApp = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceDeleteAppData, ThrowOnError>) => (options.client ?? client).delete<ConsoleServiceDeleteAppResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId_1}', ...options });

export const consoleServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceGetAppData, ThrowOnError>) => (options.client ?? client).get<ConsoleServiceGetAppResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId_1}', ...options });

export const consoleServiceCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceCreateApiKeyData, ThrowOnError>) => (options.client ?? client).post<ConsoleServiceCreateApiKeyResponses, unknown, ThrowOnError>({
    url: '/v1/apps/{appId_1}/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const consoleServiceDeleteAppKey = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceDeleteAppKeyData, ThrowOnError>) => (options.client ?? client).delete<ConsoleServiceDeleteAppKeyResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId_1}/api-keys/{apiKey}', ...options });

/**
 * Delete an application and all its associated API keys
 */
export const appServiceDeleteApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteAppData, ThrowOnError>) => (options.client ?? client).delete<AppServiceDeleteAppResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId}', ...options });

/**
 * Get a specific application by ID
 */
export const appServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceGetAppData, ThrowOnError>) => (options.client ?? client).get<AppServiceGetAppResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId}', ...options });

/**
 * List all API keys for an application
 */
export const appServiceListApiKeys = <ThrowOnError extends boolean = false>(options: Options<AppServiceListApiKeysData, ThrowOnError>) => (options.client ?? client).get<AppServiceListApiKeysResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId}/api-keys', ...options });

/**
 * Create a new API key for an application
 */
export const appServiceCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceCreateApiKeyData, ThrowOnError>) => (options.client ?? client).post<AppServiceCreateApiKeyResponses, unknown, ThrowOnError>({
    url: '/v1/apps/{appId}/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a specific API key
 */
export const appServiceDeleteApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteApiKeyData, ThrowOnError>) => (options.client ?? client).delete<AppServiceDeleteApiKeyResponses, unknown, ThrowOnError>({ url: '/v1/apps/{appId}/api-keys/{apiKey}', ...options });

export const assetGroupServiceListAssetGroups = <ThrowOnError extends boolean = false>(options?: Options<AssetGroupServiceListAssetGroupsData, ThrowOnError>) => (options?.client ?? client).get<AssetGroupServiceListAssetGroupsResponses, unknown, ThrowOnError>({ url: '/v1/asset-groups', ...options });

export const assetGroupServiceCreateAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceCreateAssetGroupData, ThrowOnError>) => (options.client ?? client).post<AssetGroupServiceCreateAssetGroupResponses, unknown, ThrowOnError>({
    url: '/v1/asset-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const assetGroupServiceDeleteAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceDeleteAssetGroupData, ThrowOnError>) => (options.client ?? client).delete<AssetGroupServiceDeleteAssetGroupResponses, unknown, ThrowOnError>({ url: '/v1/asset-groups/{id}', ...options });

export const assetGroupServiceGetAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceGetAssetGroupData, ThrowOnError>) => (options.client ?? client).get<AssetGroupServiceGetAssetGroupResponses, unknown, ThrowOnError>({ url: '/v1/asset-groups/{id}', ...options });

export const assetGroupServiceUpdateAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceUpdateAssetGroupData, ThrowOnError>) => (options.client ?? client).put<AssetGroupServiceUpdateAssetGroupResponses, unknown, ThrowOnError>({
    url: '/v1/asset-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const assetGroupServiceSyncAssetGroup = <ThrowOnError extends boolean = false>(options: Options<AssetGroupServiceSyncAssetGroupData, ThrowOnError>) => (options.client ?? client).post<AssetGroupServiceSyncAssetGroupResponses, unknown, ThrowOnError>({
    url: '/v1/asset-groups/{id}/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const assetServiceListAssets = <ThrowOnError extends boolean = false>(options?: Options<AssetServiceListAssetsData, ThrowOnError>) => (options?.client ?? client).get<AssetServiceListAssetsResponses, unknown, ThrowOnError>({ url: '/v1/assets', ...options });

export const assetServiceCreateAsset = <ThrowOnError extends boolean = false>(options: Options<AssetServiceCreateAssetData, ThrowOnError>) => (options.client ?? client).post<AssetServiceCreateAssetResponses, unknown, ThrowOnError>({
    url: '/v1/assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const assetServiceDeleteAsset = <ThrowOnError extends boolean = false>(options: Options<AssetServiceDeleteAssetData, ThrowOnError>) => (options.client ?? client).delete<AssetServiceDeleteAssetResponses, unknown, ThrowOnError>({ url: '/v1/assets/{id}', ...options });

export const assetServiceGetAsset = <ThrowOnError extends boolean = false>(options: Options<AssetServiceGetAssetData, ThrowOnError>) => (options.client ?? client).get<AssetServiceGetAssetResponses, unknown, ThrowOnError>({ url: '/v1/assets/{id}', ...options });

export const assetServiceUpdateAsset = <ThrowOnError extends boolean = false>(options: Options<AssetServiceUpdateAssetData, ThrowOnError>) => (options.client ?? client).put<AssetServiceUpdateAssetResponses, unknown, ThrowOnError>({
    url: '/v1/assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const authServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceChangePasswordData, ThrowOnError>) => (options.client ?? client).post<AuthServiceChangePasswordResponses, unknown, ThrowOnError>({
    url: '/v1/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLoginData, ThrowOnError>) => (options.client ?? client).post<AuthServiceLoginResponses, unknown, ThrowOnError>({
    url: '/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceLogout = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLogoutData, ThrowOnError>) => (options.client ?? client).post<AuthServiceLogoutResponses, unknown, ThrowOnError>({
    url: '/v1/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceMe = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceMeData, ThrowOnError>) => (options?.client ?? client).get<AuthServiceMeResponses, unknown, ThrowOnError>({ url: '/v1/auth/me', ...options });

/**
 * Login or register with OAuth
 */
export const authServiceOAuthLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceOAuthLoginData, ThrowOnError>) => (options.client ?? client).post<AuthServiceOAuthLoginResponses, unknown, ThrowOnError>({
    url: '/v1/auth/oauth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password using verification code
 */
export const authServiceResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceResetPasswordData, ThrowOnError>) => (options.client ?? client).post<AuthServiceResetPasswordResponses, unknown, ThrowOnError>({
    url: '/v1/auth/password-reset/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user profile
 */
export const authServiceUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<AuthServiceUpdateProfileData, ThrowOnError>) => (options.client ?? client).put<AuthServiceUpdateProfileResponses, unknown, ThrowOnError>({
    url: '/v1/auth/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceRegister = <ThrowOnError extends boolean = false>(options: Options<AuthServiceRegisterData, ThrowOnError>) => (options.client ?? client).post<AuthServiceRegisterResponses, unknown, ThrowOnError>({
    url: '/v1/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send an email verification code
 */
export const authServiceSendVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceSendVerificationCodeData, ThrowOnError>) => (options.client ?? client).post<AuthServiceSendVerificationCodeResponses, unknown, ThrowOnError>({
    url: '/v1/auth/verification-code/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify an email verification code
 */
export const authServiceVerifyVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceVerifyVerificationCodeData, ThrowOnError>) => (options.client ?? client).post<AuthServiceVerifyVerificationCodeResponses, unknown, ThrowOnError>({
    url: '/v1/auth/verification-code/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceListCharacterLists = <ThrowOnError extends boolean = false>(options?: Options<CharacterServiceListCharacterListsData, ThrowOnError>) => (options?.client ?? client).get<CharacterServiceListCharacterListsResponses, unknown, ThrowOnError>({ url: '/v1/character-lists', ...options });

export const characterTemplateServiceListCharacterTemplates = <ThrowOnError extends boolean = false>(options?: Options<CharacterTemplateServiceListCharacterTemplatesData, ThrowOnError>) => (options?.client ?? client).get<CharacterTemplateServiceListCharacterTemplatesResponses, unknown, ThrowOnError>({ url: '/v1/character-templates', ...options });

export const characterTemplateServiceCreateCharacterTemplate = <ThrowOnError extends boolean = false>(options: Options<CharacterTemplateServiceCreateCharacterTemplateData, ThrowOnError>) => (options.client ?? client).post<CharacterTemplateServiceCreateCharacterTemplateResponses, unknown, ThrowOnError>({
    url: '/v1/character-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterTemplateServiceDeleteCharacterTemplate = <ThrowOnError extends boolean = false>(options: Options<CharacterTemplateServiceDeleteCharacterTemplateData, ThrowOnError>) => (options.client ?? client).delete<CharacterTemplateServiceDeleteCharacterTemplateResponses, unknown, ThrowOnError>({ url: '/v1/character-templates/{id}', ...options });

export const characterTemplateServiceGetCharacterTemplate = <ThrowOnError extends boolean = false>(options: Options<CharacterTemplateServiceGetCharacterTemplateData, ThrowOnError>) => (options.client ?? client).get<CharacterTemplateServiceGetCharacterTemplateResponses, unknown, ThrowOnError>({ url: '/v1/character-templates/{id}', ...options });

export const characterTemplateServiceUpdateCharacterTemplate = <ThrowOnError extends boolean = false>(options: Options<CharacterTemplateServiceUpdateCharacterTemplateData, ThrowOnError>) => (options.client ?? client).put<CharacterTemplateServiceUpdateCharacterTemplateResponses, unknown, ThrowOnError>({
    url: '/v1/character-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceListCharacters = <ThrowOnError extends boolean = false>(options?: Options<CharacterServiceListCharactersData, ThrowOnError>) => (options?.client ?? client).get<CharacterServiceListCharactersResponses, unknown, ThrowOnError>({ url: '/v1/characters', ...options });

export const characterServiceCreateCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceCreateCharacterData, ThrowOnError>) => (options.client ?? client).post<CharacterServiceCreateCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/characters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceCopyCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceCopyCharacterData, ThrowOnError>) => (options.client ?? client).post<CharacterServiceCopyCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/characters/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceProcessCoef = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceProcessCoefData, ThrowOnError>) => (options.client ?? client).post<CharacterServiceProcessCoefResponses, unknown, ThrowOnError>({
    url: '/v1/characters/process-coef',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceSetCharacterLists = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceSetCharacterListsData, ThrowOnError>) => (options.client ?? client).put<CharacterServiceSetCharacterListsResponses, unknown, ThrowOnError>({
    url: '/v1/characters/{characterId}/lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const characterServiceDeleteCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceDeleteCharacterData, ThrowOnError>) => (options.client ?? client).delete<CharacterServiceDeleteCharacterResponses, unknown, ThrowOnError>({ url: '/v1/characters/{id}', ...options });

export const characterServiceGetCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceGetCharacterData, ThrowOnError>) => (options.client ?? client).get<CharacterServiceGetCharacterResponses, unknown, ThrowOnError>({ url: '/v1/characters/{id}', ...options });

export const characterServiceUpdateCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceUpdateCharacterData, ThrowOnError>) => (options.client ?? client).put<CharacterServiceUpdateCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/characters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lightweight character fetch optimized for console/driven-ingress.
 * Reduces Platform DB queries from 11 to 4 by skipping template, redeem,
 * asset-group created_by, and merging the asset-group fetch into one call.
 */
export const characterServiceGetCharacterLite = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceGetCharacterLiteData, ThrowOnError>) => (options.client ?? client).get<CharacterServiceGetCharacterLiteResponses, unknown, ThrowOnError>({ url: '/v1/characters/{id}/lite', ...options });

export const characterServiceSyncCharacter = <ThrowOnError extends boolean = false>(options: Options<CharacterServiceSyncCharacterData, ThrowOnError>) => (options.client ?? client).post<CharacterServiceSyncCharacterResponses, unknown, ThrowOnError>({
    url: '/v1/characters/{id}/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a short-lived browser authorization session for CLI login.
 */
export const cliAuthServiceCreateCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceCreateCliAuthSessionData, ThrowOnError>) => (options.client ?? client).post<CliAuthServiceCreateCliAuthSessionResponses, unknown, ThrowOnError>({
    url: '/v1/cli/auth/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve session details for the open-platform-web authorization page.
 */
export const cliAuthServiceGetCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceGetCliAuthSessionData, ThrowOnError>) => (options.client ?? client).get<CliAuthServiceGetCliAuthSessionResponses, unknown, ThrowOnError>({ url: '/v1/cli/auth/sessions/{authRequestId}', ...options });

/**
 * Approve the session from the logged-in web page and produce the final loopback redirect URL.
 */
export const cliAuthServiceApproveCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceApproveCliAuthSessionData, ThrowOnError>) => (options.client ?? client).post<CliAuthServiceApproveCliAuthSessionResponses, unknown, ThrowOnError>({
    url: '/v1/cli/auth/sessions/{authRequestId}:approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange auth code plus PKCE verifier for CLI tokens.
 */
export const cliAuthServiceExchangeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceExchangeCliAuthTokenData, ThrowOnError>) => (options.client ?? client).post<CliAuthServiceExchangeCliAuthTokenResponses, unknown, ThrowOnError>({
    url: '/v1/cli/auth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh an expired access token by refresh token.
 */
export const cliAuthServiceRefreshCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRefreshCliAuthTokenData, ThrowOnError>) => (options.client ?? client).post<CliAuthServiceRefreshCliAuthTokenResponses, unknown, ThrowOnError>({
    url: '/v1/cli/auth/token:refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke CLI tokens during logout.
 */
export const cliAuthServiceRevokeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRevokeCliAuthTokenData, ThrowOnError>) => (options.client ?? client).post<CliAuthServiceRevokeCliAuthTokenResponses, unknown, ThrowOnError>({
    url: '/v1/cli/auth/token:revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const configKvServiceListConfigKvs = <ThrowOnError extends boolean = false>(options?: Options<ConfigKvServiceListConfigKvsData, ThrowOnError>) => (options?.client ?? client).get<ConfigKvServiceListConfigKvsResponses, unknown, ThrowOnError>({ url: '/v1/configs', ...options });

export const configKvServiceCreateConfigKv = <ThrowOnError extends boolean = false>(options: Options<ConfigKvServiceCreateConfigKvData, ThrowOnError>) => (options.client ?? client).post<ConfigKvServiceCreateConfigKvResponses, unknown, ThrowOnError>({
    url: '/v1/configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const configKvServiceDeleteConfigKv = <ThrowOnError extends boolean = false>(options: Options<ConfigKvServiceDeleteConfigKvData, ThrowOnError>) => (options.client ?? client).delete<ConfigKvServiceDeleteConfigKvResponses, unknown, ThrowOnError>({ url: '/v1/configs/{id}', ...options });

export const configKvServiceGetConfigKv = <ThrowOnError extends boolean = false>(options: Options<ConfigKvServiceGetConfigKvData, ThrowOnError>) => (options.client ?? client).get<ConfigKvServiceGetConfigKvResponses, unknown, ThrowOnError>({ url: '/v1/configs/{id}', ...options });

export const configKvServiceUpdateConfigKv = <ThrowOnError extends boolean = false>(options: Options<ConfigKvServiceUpdateConfigKvData, ThrowOnError>) => (options.client ?? client).put<ConfigKvServiceUpdateConfigKvResponses, unknown, ThrowOnError>({
    url: '/v1/configs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectionTaskServiceListCollectionTasks = <ThrowOnError extends boolean = false>(options?: Options<CollectionTaskServiceListCollectionTasksData, ThrowOnError>) => (options?.client ?? client).get<CollectionTaskServiceListCollectionTasksResponses, unknown, ThrowOnError>({ url: '/v1/console/collection-tasks', ...options });

/**
 * CollectionTask operations
 */
export const collectionTaskServiceCreateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceCreateCollectionTaskData, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceCreateCollectionTaskResponses, unknown, ThrowOnError>({
    url: '/v1/console/collection-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectionTaskServiceDeleteCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceDeleteCollectionTaskData, ThrowOnError>) => (options.client ?? client).delete<CollectionTaskServiceDeleteCollectionTaskResponses, unknown, ThrowOnError>({ url: '/v1/console/collection-tasks/{id}', ...options });

export const collectionTaskServiceGetCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskData, ThrowOnError>) => (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskResponses, unknown, ThrowOnError>({ url: '/v1/console/collection-tasks/{id}', ...options });

export const collectionTaskServiceUpdateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceUpdateCollectionTaskData, ThrowOnError>) => (options.client ?? client).put<CollectionTaskServiceUpdateCollectionTaskResponses, unknown, ThrowOnError>({
    url: '/v1/console/collection-tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取容器镜像列表
 */
export const instanceManagementServiceListContainerImages = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListContainerImagesData, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListContainerImagesResponses, unknown, ThrowOnError>({ url: '/v1/console/container-images', ...options });

/**
 * 获取容器镜像标签列表
 */
export const instanceManagementServiceListContainerImageTags = <ThrowOnError extends boolean = false>(options: Options<InstanceManagementServiceListContainerImageTagsData, ThrowOnError>) => (options.client ?? client).get<InstanceManagementServiceListContainerImageTagsResponses, unknown, ThrowOnError>({ url: '/v1/console/container-images/{namespace}/{repositoryName}/tags', ...options });

/**
 * 获取实例列表
 */
export const instanceManagementServiceListInstances = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListInstancesData, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListInstancesResponses, unknown, ThrowOnError>({ url: '/v1/console/instances', ...options });

/**
 * 获取启动模板列表
 */
export const instanceManagementServiceListLaunchTemplates = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListLaunchTemplatesData, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListLaunchTemplatesResponses, unknown, ThrowOnError>({ url: '/v1/console/launch-templates', ...options });

export const materialServiceListMaterials = <ThrowOnError extends boolean = false>(options?: Options<MaterialServiceListMaterialsData, ThrowOnError>) => (options?.client ?? client).get<MaterialServiceListMaterialsResponses, unknown, ThrowOnError>({ url: '/v1/console/materials', ...options });

export const materialServiceCreateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceCreateMaterialData, ThrowOnError>) => (options.client ?? client).post<MaterialServiceCreateMaterialResponses, unknown, ThrowOnError>({
    url: '/v1/console/materials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const materialServiceDeleteMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceDeleteMaterialData, ThrowOnError>) => (options.client ?? client).delete<MaterialServiceDeleteMaterialResponses, unknown, ThrowOnError>({ url: '/v1/console/materials/{id}', ...options });

export const materialServiceGetMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceGetMaterialData, ThrowOnError>) => (options.client ?? client).get<MaterialServiceGetMaterialResponses, unknown, ThrowOnError>({ url: '/v1/console/materials/{id}', ...options });

export const materialServiceUpdateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceUpdateMaterialData, ThrowOnError>) => (options.client ?? client).put<MaterialServiceUpdateMaterialResponses, unknown, ThrowOnError>({
    url: '/v1/console/materials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const materialServiceAdjustMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceAdjustMaterialData, ThrowOnError>) => (options.client ?? client).post<MaterialServiceAdjustMaterialResponses, unknown, ThrowOnError>({
    url: '/v1/console/materials/{id}/adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const consoleServiceGetOssCredentials = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceGetOssCredentialsData, ThrowOnError>) => (options.client ?? client).post<ConsoleServiceGetOssCredentialsResponses, unknown, ThrowOnError>({
    url: '/v1/console/oss-credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pipeTemplateServiceListPipeTemplates = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListPipeTemplatesData, ThrowOnError>) => (options?.client ?? client).get<PipeTemplateServiceListPipeTemplatesResponses, unknown, ThrowOnError>({ url: '/v1/console/pipe-templates', ...options });

export const pipeTemplateServiceCreatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceCreatePipeTemplateData, ThrowOnError>) => (options.client ?? client).post<PipeTemplateServiceCreatePipeTemplateResponses, unknown, ThrowOnError>({
    url: '/v1/console/pipe-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pipeTemplateServiceListTrackerVersions = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListTrackerVersionsData, ThrowOnError>) => (options?.client ?? client).get<PipeTemplateServiceListTrackerVersionsResponses, unknown, ThrowOnError>({ url: '/v1/console/pipe-templates/tracker-versions', ...options });

export const pipeTemplateServiceDeletePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceDeletePipeTemplateData, ThrowOnError>) => (options.client ?? client).delete<PipeTemplateServiceDeletePipeTemplateResponses, unknown, ThrowOnError>({ url: '/v1/console/pipe-templates/{id}', ...options });

export const pipeTemplateServiceGetPipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceGetPipeTemplateData, ThrowOnError>) => (options.client ?? client).get<PipeTemplateServiceGetPipeTemplateResponses, unknown, ThrowOnError>({ url: '/v1/console/pipe-templates/{id}', ...options });

export const pipeTemplateServiceUpdatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceUpdatePipeTemplateData, ThrowOnError>) => (options.client ?? client).put<PipeTemplateServiceUpdatePipeTemplateResponses, unknown, ThrowOnError>({
    url: '/v1/console/pipe-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const consoleServiceCreateSessionToken = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceCreateSessionTokenData, ThrowOnError>) => (options.client ?? client).post<ConsoleServiceCreateSessionTokenResponses, unknown, ThrowOnError>({
    url: '/v1/console/session-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceListStatuses = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListStatusesData, ThrowOnError>) => (options?.client ?? client).get<TaskServiceListStatusesResponses, unknown, ThrowOnError>({ url: '/v1/console/statuses', ...options });

/**
 * Status operations
 */
export const taskServiceCreateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateStatusData, ThrowOnError>) => (options.client ?? client).post<TaskServiceCreateStatusResponses, unknown, ThrowOnError>({
    url: '/v1/console/statuses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceDeleteStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteStatusData, ThrowOnError>) => (options.client ?? client).delete<TaskServiceDeleteStatusResponses, unknown, ThrowOnError>({ url: '/v1/console/statuses/{id}', ...options });

export const taskServiceGetStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetStatusData, ThrowOnError>) => (options.client ?? client).get<TaskServiceGetStatusResponses, unknown, ThrowOnError>({ url: '/v1/console/statuses/{id}', ...options });

export const taskServiceUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateStatusData, ThrowOnError>) => (options.client ?? client).put<TaskServiceUpdateStatusResponses, unknown, ThrowOnError>({
    url: '/v1/console/statuses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceListTasks = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListTasksData, ThrowOnError>) => (options?.client ?? client).get<TaskServiceListTasksResponses, unknown, ThrowOnError>({ url: '/v1/console/tasks', ...options });

/**
 * Task operations
 */
export const taskServiceCreateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateTaskData, ThrowOnError>) => (options.client ?? client).post<TaskServiceCreateTaskResponses, unknown, ThrowOnError>({
    url: '/v1/console/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get task statistics
 */
export const taskServiceGetTaskStats = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceGetTaskStatsData, ThrowOnError>) => (options?.client ?? client).get<TaskServiceGetTaskStatsResponses, unknown, ThrowOnError>({ url: '/v1/console/tasks/stats', ...options });

export const taskServiceDeleteTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteTaskData, ThrowOnError>) => (options.client ?? client).delete<TaskServiceDeleteTaskResponses, unknown, ThrowOnError>({ url: '/v1/console/tasks/{id}', ...options });

export const taskServiceGetTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetTaskData, ThrowOnError>) => (options.client ?? client).get<TaskServiceGetTaskResponses, unknown, ThrowOnError>({ url: '/v1/console/tasks/{id}', ...options });

export const taskServiceUpdateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateTaskData, ThrowOnError>) => (options.client ?? client).put<TaskServiceUpdateTaskResponses, unknown, ThrowOnError>({
    url: '/v1/console/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminate task instances
 */
export const taskServiceTerminateTaskInstances = <ThrowOnError extends boolean = false>(options: Options<TaskServiceTerminateTaskInstancesData, ThrowOnError>) => (options.client ?? client).post<TaskServiceTerminateTaskInstancesResponses, unknown, ThrowOnError>({
    url: '/v1/console/tasks/{id}/terminate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取容器镜像列表
 */
export const instanceManagementServiceListContainerImages2 = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListContainerImages2Data, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListContainerImages2Responses, unknown, ThrowOnError>({ url: '/v1/container-images', ...options });

/**
 * 获取容器镜像标签列表
 */
export const instanceManagementServiceListContainerImageTags2 = <ThrowOnError extends boolean = false>(options: Options<InstanceManagementServiceListContainerImageTags2Data, ThrowOnError>) => (options.client ?? client).get<InstanceManagementServiceListContainerImageTags2Responses, unknown, ThrowOnError>({ url: '/v1/container-images/{namespace}/{repositoryName}/tags', ...options });

/**
 * List GPU tasks with filters
 */
export const gpuTaskServiceListGpuTasks = <ThrowOnError extends boolean = false>(options?: Options<GpuTaskServiceListGpuTasksData, ThrowOnError>) => (options?.client ?? client).get<GpuTaskServiceListGpuTasksResponses, unknown, ThrowOnError>({ url: '/v1/gpu-tasks', ...options });

/**
 * Create a new GPU task
 */
export const gpuTaskServiceCreateGpuTask = <ThrowOnError extends boolean = false>(options: Options<GpuTaskServiceCreateGpuTaskData, ThrowOnError>) => (options.client ?? client).post<GpuTaskServiceCreateGpuTaskResponses, unknown, ThrowOnError>({
    url: '/v1/gpu-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report heartbeat from worker
 */
export const gpuTaskCallbackServiceReportHeartbeat = <ThrowOnError extends boolean = false>(options: Options<GpuTaskCallbackServiceReportHeartbeatData, ThrowOnError>) => (options.client ?? client).post<GpuTaskCallbackServiceReportHeartbeatResponses, unknown, ThrowOnError>({
    url: '/v1/gpu-tasks/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload results from worker
 */
export const gpuTaskCallbackServiceUploadResults = <ThrowOnError extends boolean = false>(options: Options<GpuTaskCallbackServiceUploadResultsData, ThrowOnError>) => (options.client ?? client).post<GpuTaskCallbackServiceUploadResultsResponses, unknown, ThrowOnError>({
    url: '/v1/gpu-tasks/results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get GPU task statistics
 */
export const gpuTaskServiceGetGpuTaskStats = <ThrowOnError extends boolean = false>(options?: Options<GpuTaskServiceGetGpuTaskStatsData, ThrowOnError>) => (options?.client ?? client).get<GpuTaskServiceGetGpuTaskStatsResponses, unknown, ThrowOnError>({ url: '/v1/gpu-tasks/stats', ...options });

/**
 * List OSS videos by prefix for batch task creation.
 */
export const gpuTaskServiceListOssVideos = <ThrowOnError extends boolean = false>(options?: Options<GpuTaskServiceListOssVideosData, ThrowOnError>) => (options?.client ?? client).get<GpuTaskServiceListOssVideosResponses, unknown, ThrowOnError>({ url: '/v1/gpu-tasks/videos', ...options });

/**
 * Get a GPU task by ID
 */
export const gpuTaskServiceGetGpuTask = <ThrowOnError extends boolean = false>(options: Options<GpuTaskServiceGetGpuTaskData, ThrowOnError>) => (options.client ?? client).get<GpuTaskServiceGetGpuTaskResponses, unknown, ThrowOnError>({ url: '/v1/gpu-tasks/{id}', ...options });

/**
 * Cancel a GPU task
 */
export const gpuTaskServiceCancelGpuTask = <ThrowOnError extends boolean = false>(options: Options<GpuTaskServiceCancelGpuTaskData, ThrowOnError>) => (options.client ?? client).post<GpuTaskServiceCancelGpuTaskResponses, unknown, ThrowOnError>({
    url: '/v1/gpu-tasks/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get GPU task logs from Gongji
 */
export const gpuTaskServiceGetGpuTaskLogs = <ThrowOnError extends boolean = false>(options: Options<GpuTaskServiceGetGpuTaskLogsData, ThrowOnError>) => (options.client ?? client).get<GpuTaskServiceGetGpuTaskLogsResponses, unknown, ThrowOnError>({ url: '/v1/gpu-tasks/{id}/logs', ...options });

/**
 * Retry a failed GPU task
 */
export const gpuTaskServiceRetryGpuTask = <ThrowOnError extends boolean = false>(options: Options<GpuTaskServiceRetryGpuTaskData, ThrowOnError>) => (options.client ?? client).post<GpuTaskServiceRetryGpuTaskResponses, unknown, ThrowOnError>({
    url: '/v1/gpu-tasks/{id}/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取实例列表
 */
export const instanceManagementServiceListInstances2 = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListInstances2Data, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListInstances2Responses, unknown, ThrowOnError>({ url: '/v1/instances', ...options });

/**
 * GetRegionStats returns this region's real-time stats from local driven-ingress
 * Called by other regions' Console to fetch local stats
 */
export const drivenStatsServiceGetRegionStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetRegionStatsData, ThrowOnError>) => (options?.client ?? client).get<DrivenStatsServiceGetRegionStatsResponses, unknown, ThrowOnError>({ url: '/v1/internal/driven-stats/region', ...options });

/**
 * SyncDrivenStats syncs usage and concurrency stats from remote regions to the primary database
 * This endpoint is called by remote region backup jobs
 */
export const drivenStatsServiceSyncDrivenStats = <ThrowOnError extends boolean = false>(options: Options<DrivenStatsServiceSyncDrivenStatsData, ThrowOnError>) => (options.client ?? client).post<DrivenStatsServiceSyncDrivenStatsResponses, unknown, ThrowOnError>({
    url: '/v1/internal/driven-stats/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列表JoiAvatar
 */
export const joiAvatarServiceListJoiAvatars = <ThrowOnError extends boolean = false>(options?: Options<JoiAvatarServiceListJoiAvatarsData, ThrowOnError>) => (options?.client ?? client).get<JoiAvatarServiceListJoiAvatarsResponses, unknown, ThrowOnError>({ url: '/v1/joi-avatars', ...options });

/**
 * 删除JoiAvatar
 */
export const joiAvatarServiceDeleteJoiAvatar = <ThrowOnError extends boolean = false>(options: Options<JoiAvatarServiceDeleteJoiAvatarData, ThrowOnError>) => (options.client ?? client).delete<JoiAvatarServiceDeleteJoiAvatarResponses, unknown, ThrowOnError>({ url: '/v1/joi-avatars/{id}', ...options });

/**
 * 列表Joi模型申请
 */
export const joiModelApplyServiceListJoiModelApplies = <ThrowOnError extends boolean = false>(options?: Options<JoiModelApplyServiceListJoiModelAppliesData, ThrowOnError>) => (options?.client ?? client).get<JoiModelApplyServiceListJoiModelAppliesResponses, unknown, ThrowOnError>({ url: '/v1/joi-model-applies', ...options });

/**
 * 获取Joi模型申请统计（按时间范围和状态聚合）
 */
export const joiModelApplyServiceGetJoiModelApplyStats = <ThrowOnError extends boolean = false>(options?: Options<JoiModelApplyServiceGetJoiModelApplyStatsData, ThrowOnError>) => (options?.client ?? client).get<JoiModelApplyServiceGetJoiModelApplyStatsResponses, unknown, ThrowOnError>({ url: '/v1/joi-model-applies/stats', ...options });

/**
 * 列表JoiTaskCallback
 */
export const joiTaskCallbackServiceListJoiTaskCallbacks = <ThrowOnError extends boolean = false>(options?: Options<JoiTaskCallbackServiceListJoiTaskCallbacksData, ThrowOnError>) => (options?.client ?? client).get<JoiTaskCallbackServiceListJoiTaskCallbacksResponses, unknown, ThrowOnError>({ url: '/v1/joi-task-callbacks', ...options });

/**
 * 获取启动模板列表
 */
export const instanceManagementServiceListLaunchTemplates2 = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListLaunchTemplates2Data, ThrowOnError>) => (options?.client ?? client).get<InstanceManagementServiceListLaunchTemplates2Responses, unknown, ThrowOnError>({ url: '/v1/launch-templates', ...options });

export const materialServiceListMaterials2 = <ThrowOnError extends boolean = false>(options?: Options<MaterialServiceListMaterials2Data, ThrowOnError>) => (options?.client ?? client).get<MaterialServiceListMaterials2Responses, unknown, ThrowOnError>({ url: '/v1/materials', ...options });

export const materialServiceCreateMaterial2 = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceCreateMaterial2Data, ThrowOnError>) => (options.client ?? client).post<MaterialServiceCreateMaterial2Responses, unknown, ThrowOnError>({
    url: '/v1/materials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const materialServiceDeleteMaterial2 = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceDeleteMaterial2Data, ThrowOnError>) => (options.client ?? client).delete<MaterialServiceDeleteMaterial2Responses, unknown, ThrowOnError>({ url: '/v1/materials/{id}', ...options });

export const materialServiceGetMaterial2 = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceGetMaterial2Data, ThrowOnError>) => (options.client ?? client).get<MaterialServiceGetMaterial2Responses, unknown, ThrowOnError>({ url: '/v1/materials/{id}', ...options });

export const materialServiceUpdateMaterial2 = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceUpdateMaterial2Data, ThrowOnError>) => (options.client ?? client).put<MaterialServiceUpdateMaterial2Responses, unknown, ThrowOnError>({
    url: '/v1/materials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const materialServiceAdjustMaterial2 = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceAdjustMaterial2Data, ThrowOnError>) => (options.client ?? client).post<MaterialServiceAdjustMaterial2Responses, unknown, ThrowOnError>({
    url: '/v1/materials/{id}/adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ossServiceGetOssCredentials = <ThrowOnError extends boolean = false>(options: Options<OssServiceGetOssCredentialsData, ThrowOnError>) => (options.client ?? client).post<OssServiceGetOssCredentialsResponses, unknown, ThrowOnError>({
    url: '/v1/oss/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pipeTemplateServiceListPipeTemplates2 = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListPipeTemplates2Data, ThrowOnError>) => (options?.client ?? client).get<PipeTemplateServiceListPipeTemplates2Responses, unknown, ThrowOnError>({ url: '/v1/pipe-templates', ...options });

export const pipeTemplateServiceCreatePipeTemplate2 = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceCreatePipeTemplate2Data, ThrowOnError>) => (options.client ?? client).post<PipeTemplateServiceCreatePipeTemplate2Responses, unknown, ThrowOnError>({
    url: '/v1/pipe-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pipeTemplateServiceListTrackerVersions2 = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListTrackerVersions2Data, ThrowOnError>) => (options?.client ?? client).get<PipeTemplateServiceListTrackerVersions2Responses, unknown, ThrowOnError>({ url: '/v1/pipe-templates/tracker-versions', ...options });

export const pipeTemplateServiceDeletePipeTemplate2 = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceDeletePipeTemplate2Data, ThrowOnError>) => (options.client ?? client).delete<PipeTemplateServiceDeletePipeTemplate2Responses, unknown, ThrowOnError>({ url: '/v1/pipe-templates/{id}', ...options });

export const pipeTemplateServiceGetPipeTemplate2 = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceGetPipeTemplate2Data, ThrowOnError>) => (options.client ?? client).get<PipeTemplateServiceGetPipeTemplate2Responses, unknown, ThrowOnError>({ url: '/v1/pipe-templates/{id}', ...options });

export const pipeTemplateServiceUpdatePipeTemplate2 = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceUpdatePipeTemplate2Data, ThrowOnError>) => (options.client ?? client).put<PipeTemplateServiceUpdatePipeTemplate2Responses, unknown, ThrowOnError>({
    url: '/v1/pipe-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectionTaskServiceListCollectionTasks2 = <ThrowOnError extends boolean = false>(options?: Options<CollectionTaskServiceListCollectionTasks2Data, ThrowOnError>) => (options?.client ?? client).get<CollectionTaskServiceListCollectionTasks2Responses, unknown, ThrowOnError>({ url: '/v1/platform/collection-tasks', ...options });

/**
 * CollectionTask operations
 */
export const collectionTaskServiceCreateCollectionTask2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceCreateCollectionTask2Data, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceCreateCollectionTask2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/collection-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectionTaskServiceDeleteCollectionTask2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceDeleteCollectionTask2Data, ThrowOnError>) => (options.client ?? client).delete<CollectionTaskServiceDeleteCollectionTask2Responses, unknown, ThrowOnError>({ url: '/v1/platform/collection-tasks/{id}', ...options });

export const collectionTaskServiceGetCollectionTask2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTask2Data, ThrowOnError>) => (options.client ?? client).get<CollectionTaskServiceGetCollectionTask2Responses, unknown, ThrowOnError>({ url: '/v1/platform/collection-tasks/{id}', ...options });

export const collectionTaskServiceUpdateCollectionTask2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceUpdateCollectionTask2Data, ThrowOnError>) => (options.client ?? client).put<CollectionTaskServiceUpdateCollectionTask2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/collection-tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectiveEvaluationServiceCreateCollectiveEvaluation = <ThrowOnError extends boolean = false>(options: Options<CollectiveEvaluationServiceCreateCollectiveEvaluationData, ThrowOnError>) => (options.client ?? client).post<CollectiveEvaluationServiceCreateCollectiveEvaluationResponses, unknown, ThrowOnError>({
    url: '/v1/platform/model-evaluation/collective-evaluations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectiveEvaluationServiceListCollectiveEvaluationGroupVotes = <ThrowOnError extends boolean = false>(options: Options<CollectiveEvaluationServiceListCollectiveEvaluationGroupVotesData, ThrowOnError>) => (options.client ?? client).get<CollectiveEvaluationServiceListCollectiveEvaluationGroupVotesResponses, unknown, ThrowOnError>({ url: '/v1/platform/model-evaluation/collective-evaluations/{evaluationId}/votes', ...options });

export const collectiveEvaluationServiceSubmitCollectiveEvaluationVote = <ThrowOnError extends boolean = false>(options: Options<CollectiveEvaluationServiceSubmitCollectiveEvaluationVoteData, ThrowOnError>) => (options.client ?? client).post<CollectiveEvaluationServiceSubmitCollectiveEvaluationVoteResponses, unknown, ThrowOnError>({
    url: '/v1/platform/model-evaluation/collective-evaluations/{evaluationId}/votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const collectiveEvaluationServiceGetCollectiveEvaluation = <ThrowOnError extends boolean = false>(options: Options<CollectiveEvaluationServiceGetCollectiveEvaluationData, ThrowOnError>) => (options.client ?? client).get<CollectiveEvaluationServiceGetCollectiveEvaluationResponses, unknown, ThrowOnError>({ url: '/v1/platform/model-evaluation/collective-evaluations/{id}', ...options });

export const taskServiceListStatuses2 = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListStatuses2Data, ThrowOnError>) => (options?.client ?? client).get<TaskServiceListStatuses2Responses, unknown, ThrowOnError>({ url: '/v1/platform/statuses', ...options });

/**
 * Status operations
 */
export const taskServiceCreateStatus2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateStatus2Data, ThrowOnError>) => (options.client ?? client).post<TaskServiceCreateStatus2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/statuses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceDeleteStatus2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteStatus2Data, ThrowOnError>) => (options.client ?? client).delete<TaskServiceDeleteStatus2Responses, unknown, ThrowOnError>({ url: '/v1/platform/statuses/{id}', ...options });

export const taskServiceGetStatus2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetStatus2Data, ThrowOnError>) => (options.client ?? client).get<TaskServiceGetStatus2Responses, unknown, ThrowOnError>({ url: '/v1/platform/statuses/{id}', ...options });

export const taskServiceUpdateStatus2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateStatus2Data, ThrowOnError>) => (options.client ?? client).put<TaskServiceUpdateStatus2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/statuses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceListTasks2 = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListTasks2Data, ThrowOnError>) => (options?.client ?? client).get<TaskServiceListTasks2Responses, unknown, ThrowOnError>({ url: '/v1/platform/tasks', ...options });

/**
 * Task operations
 */
export const taskServiceCreateTask2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateTask2Data, ThrowOnError>) => (options.client ?? client).post<TaskServiceCreateTask2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get task statistics
 */
export const taskServiceGetTaskStats2 = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceGetTaskStats2Data, ThrowOnError>) => (options?.client ?? client).get<TaskServiceGetTaskStats2Responses, unknown, ThrowOnError>({ url: '/v1/platform/tasks/stats', ...options });

export const taskServiceDeleteTask2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteTask2Data, ThrowOnError>) => (options.client ?? client).delete<TaskServiceDeleteTask2Responses, unknown, ThrowOnError>({ url: '/v1/platform/tasks/{id}', ...options });

export const taskServiceGetTask2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetTask2Data, ThrowOnError>) => (options.client ?? client).get<TaskServiceGetTask2Responses, unknown, ThrowOnError>({ url: '/v1/platform/tasks/{id}', ...options });

export const taskServiceUpdateTask2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateTask2Data, ThrowOnError>) => (options.client ?? client).put<TaskServiceUpdateTask2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminate task instances
 */
export const taskServiceTerminateTaskInstances2 = <ThrowOnError extends boolean = false>(options: Options<TaskServiceTerminateTaskInstances2Data, ThrowOnError>) => (options.client ?? client).post<TaskServiceTerminateTaskInstances2Responses, unknown, ThrowOnError>({
    url: '/v1/platform/tasks/{id}/terminate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const taskServiceBatchCreateTasks = <ThrowOnError extends boolean = false>(options: Options<TaskServiceBatchCreateTasksData, ThrowOnError>) => (options.client ?? client).post<TaskServiceBatchCreateTasksResponses, unknown, ThrowOnError>({
    url: '/v1/platform/tasks:batchCreate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stage 1: Auto-crop image for avatar preparation
 */
export const preprocessServiceCropImage = <ThrowOnError extends boolean = false>(options: Options<PreprocessServiceCropImageData, ThrowOnError>) => (options.client ?? client).post<PreprocessServiceCropImageResponses, unknown, ThrowOnError>({
    url: '/v1/preprocess/crop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stage 2: Pose adjustment (manual trigger)
 */
export const preprocessServicePoseAdjust = <ThrowOnError extends boolean = false>(options: Options<PreprocessServicePoseAdjustData, ThrowOnError>) => (options.client ?? client).post<PreprocessServicePoseAdjustResponses, unknown, ThrowOnError>({
    url: '/v1/preprocess/pose-adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const providerServiceListProviders = <ThrowOnError extends boolean = false>(options?: Options<ProviderServiceListProvidersData, ThrowOnError>) => (options?.client ?? client).get<ProviderServiceListProvidersResponses, unknown, ThrowOnError>({ url: '/v1/providers', ...options });

export const providerServiceCreateProvider = <ThrowOnError extends boolean = false>(options: Options<ProviderServiceCreateProviderData, ThrowOnError>) => (options.client ?? client).post<ProviderServiceCreateProviderResponses, unknown, ThrowOnError>({
    url: '/v1/providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const providerServiceDeleteProvider = <ThrowOnError extends boolean = false>(options: Options<ProviderServiceDeleteProviderData, ThrowOnError>) => (options.client ?? client).delete<ProviderServiceDeleteProviderResponses, unknown, ThrowOnError>({ url: '/v1/providers/{id}', ...options });

export const providerServiceGetProvider = <ThrowOnError extends boolean = false>(options: Options<ProviderServiceGetProviderData, ThrowOnError>) => (options.client ?? client).get<ProviderServiceGetProviderResponses, unknown, ThrowOnError>({ url: '/v1/providers/{id}', ...options });

export const providerServiceUpdateProvider = <ThrowOnError extends boolean = false>(options: Options<ProviderServiceUpdateProviderData, ThrowOnError>) => (options.client ?? client).put<ProviderServiceUpdateProviderResponses, unknown, ThrowOnError>({
    url: '/v1/providers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get collection task by share token (forwarded to console)
 */
export const collectionTaskServiceGetCollectionTaskByToken = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskByTokenData, ThrowOnError>) => (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskByTokenResponses, unknown, ThrowOnError>({ url: '/v1/public/collection-tasks/{token_1}', ...options });

/**
 * Get OSS credentials for collection task upload (forwarded to console)
 */
export const collectionTaskServiceGetCollectionTaskOssCredentials = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskOssCredentialsData, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, unknown, ThrowOnError>({
    url: '/v1/public/collection-tasks/{token_1}/oss-credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit uploaded file (forwarded to console)
 */
export const collectionTaskServiceSubmitCollectionFile = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceSubmitCollectionFileData, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceSubmitCollectionFileResponses, unknown, ThrowOnError>({
    url: '/v1/public/collection-tasks/{token_1}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get collection task by share token
 */
export const collectionTaskServiceGetCollectionTaskByToken2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskByToken2Data, ThrowOnError>) => (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskByToken2Responses, unknown, ThrowOnError>({ url: '/v1/public/collection-tasks/{token}', ...options });

/**
 * Get OSS credentials for file upload
 */
export const collectionTaskServiceGetCollectionTaskOssCredentials2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskOssCredentials2Data, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceGetCollectionTaskOssCredentials2Responses, unknown, ThrowOnError>({
    url: '/v1/public/collection-tasks/{token}/oss-credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit uploaded file and create material
 */
export const collectionTaskServiceSubmitCollectionFile2 = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceSubmitCollectionFile2Data, ThrowOnError>) => (options.client ?? client).post<CollectionTaskServiceSubmitCollectionFile2Responses, unknown, ThrowOnError>({
    url: '/v1/public/collection-tasks/{token}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const redeemServiceListRedeems = <ThrowOnError extends boolean = false>(options?: Options<RedeemServiceListRedeemsData, ThrowOnError>) => (options?.client ?? client).get<RedeemServiceListRedeemsResponses, unknown, ThrowOnError>({ url: '/v1/redeems', ...options });

export const redeemServiceCreateRedeem = <ThrowOnError extends boolean = false>(options: Options<RedeemServiceCreateRedeemData, ThrowOnError>) => (options.client ?? client).post<RedeemServiceCreateRedeemResponses, unknown, ThrowOnError>({
    url: '/v1/redeems',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const redeemServiceGetRedeem = <ThrowOnError extends boolean = false>(options: Options<RedeemServiceGetRedeemData, ThrowOnError>) => (options.client ?? client).get<RedeemServiceGetRedeemResponses, unknown, ThrowOnError>({ url: '/v1/redeems/{characterId}', ...options });

export const redeemServiceUpdateRedeem = <ThrowOnError extends boolean = false>(options: Options<RedeemServiceUpdateRedeemData, ThrowOnError>) => (options.client ?? client).put<RedeemServiceUpdateRedeemResponses, unknown, ThrowOnError>({
    url: '/v1/redeems/{characterId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列表短信发送日志
 */
export const smsSendLogServiceListSmsSendLogs = <ThrowOnError extends boolean = false>(options?: Options<SmsSendLogServiceListSmsSendLogsData, ThrowOnError>) => (options?.client ?? client).get<SmsSendLogServiceListSmsSendLogsResponses, unknown, ThrowOnError>({ url: '/v1/sms-send-logs', ...options });

export const taskHeartbeatServiceHeartbeat = <ThrowOnError extends boolean = false>(options: Options<TaskHeartbeatServiceHeartbeatData, ThrowOnError>) => (options.client ?? client).post<TaskHeartbeatServiceHeartbeatResponses, unknown, ThrowOnError>({
    url: '/v1/task-heartbeat/{instanceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<UserServiceListUsersData, ThrowOnError>) => (options?.client ?? client).get<UserServiceListUsersResponses, unknown, ThrowOnError>({ url: '/v1/users', ...options });

export const userServiceCreateUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceCreateUserData, ThrowOnError>) => (options.client ?? client).post<UserServiceCreateUserResponses, unknown, ThrowOnError>({
    url: '/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceDeleteUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceDeleteUserData, ThrowOnError>) => (options.client ?? client).delete<UserServiceDeleteUserResponses, unknown, ThrowOnError>({ url: '/v1/users/{id}', ...options });

export const userServiceGetUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceGetUserData, ThrowOnError>) => (options.client ?? client).get<UserServiceGetUserResponses, unknown, ThrowOnError>({ url: '/v1/users/{id}', ...options });

export const userServiceUpdateUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceUpdateUserData, ThrowOnError>) => (options.client ?? client).put<UserServiceUpdateUserResponses, unknown, ThrowOnError>({
    url: '/v1/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all avatar applies with user information
 */
export const adminAvatarApplyServiceAdminListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarApplyServiceAdminListAvatarAppliesData, ThrowOnError>) => (options?.client ?? client).get<AdminAvatarApplyServiceAdminListAvatarAppliesResponses, unknown, ThrowOnError>({ url: '/v2/admin/avatar-applies', ...options });

/**
 * Delete an avatar apply record
 */
export const adminAvatarApplyServiceAdminDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarApplyServiceAdminDeleteAvatarApplyData, ThrowOnError>) => (options.client ?? client).delete<AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, unknown, ThrowOnError>({ url: '/v2/admin/avatar-applies/{id}', ...options });

/**
 * 获取所有充值包（包含未上架的）
 */
export const adminBillingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListCreditPackagesData, ThrowOnError>) => (options?.client ?? client).get<AdminBillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/credit-packages', ...options });

/**
 * 创建充值包
 */
export const adminBillingServiceCreateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreateCreditPackageData, ThrowOnError>) => (options.client ?? client).post<AdminBillingServiceCreateCreditPackageResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/credit-packages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 删除充值包（软删除）
 */
export const adminBillingServiceDeleteCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeleteCreditPackageData, ThrowOnError>) => (options.client ?? client).delete<AdminBillingServiceDeleteCreditPackageResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/credit-packages/{packageId}', ...options });

/**
 * 更新充值包
 */
export const adminBillingServiceUpdateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateCreditPackageData, ThrowOnError>) => (options.client ?? client).put<AdminBillingServiceUpdateCreditPackageResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/credit-packages/{packageId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 扣减用户 Credits
 */
export const adminBillingServiceDeductCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeductCreditsData, ThrowOnError>) => (options.client ?? client).post<AdminBillingServiceDeductCreditsResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/credits/deduct',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 赠送 Credits 给用户
 */
export const adminBillingServiceGrantCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGrantCreditsData, ThrowOnError>) => (options.client ?? client).post<AdminBillingServiceGrantCreditsResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/credits/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取所有订阅计划（包含非公开的）
 */
export const adminBillingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListPlansData, ThrowOnError>) => (options?.client ?? client).get<AdminBillingServiceListPlansResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/plans', ...options });

/**
 * 创建订阅计划
 */
export const adminBillingServiceCreatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreatePlanData, ThrowOnError>) => (options.client ?? client).post<AdminBillingServiceCreatePlanResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 删除订阅计划（软删除）
 */
export const adminBillingServiceDeletePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeletePlanData, ThrowOnError>) => (options.client ?? client).delete<AdminBillingServiceDeletePlanResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/plans/{planId}', ...options });

/**
 * 获取单个订阅计划详情
 */
export const adminBillingServiceGetPlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetPlanData, ThrowOnError>) => (options.client ?? client).get<AdminBillingServiceGetPlanResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/plans/{planId}', ...options });

/**
 * 更新订阅计划
 */
export const adminBillingServiceUpdatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdatePlanData, ThrowOnError>) => (options.client ?? client).put<AdminBillingServiceUpdatePlanResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/plans/{planId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取计费统计概览
 */
export const adminBillingServiceGetBillingStats = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceGetBillingStatsData, ThrowOnError>) => (options?.client ?? client).get<AdminBillingServiceGetBillingStatsResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/stats', ...options });

/**
 * 获取所有用户订阅列表
 */
export const adminBillingServiceListSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListSubscriptionsData, ThrowOnError>) => (options?.client ?? client).get<AdminBillingServiceListSubscriptionsResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/subscriptions', ...options });

/**
 * 获取用户 Credits 余额
 */
export const adminBillingServiceGetUserCreditBalance = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserCreditBalanceData, ThrowOnError>) => (options.client ?? client).get<AdminBillingServiceGetUserCreditBalanceResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/users/{userId}/credits', ...options });

/**
 * 获取用户 Credits 交易记录
 */
export const adminBillingServiceListUserCreditTransactions = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditTransactionsData, ThrowOnError>) => (options.client ?? client).get<AdminBillingServiceListUserCreditTransactionsResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/users/{userId}/credits/transactions', ...options });

/**
 * 获取用户消费明细
 */
export const adminBillingServiceListUserCreditUsages = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditUsagesData, ThrowOnError>) => (options.client ?? client).get<AdminBillingServiceListUserCreditUsagesResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/users/{userId}/credits/usages', ...options });

/**
 * 获取指定用户的订阅信息
 */
export const adminBillingServiceGetUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserSubscriptionData, ThrowOnError>) => (options.client ?? client).get<AdminBillingServiceGetUserSubscriptionResponses, unknown, ThrowOnError>({ url: '/v2/admin/billing/users/{userId}/subscription', ...options });

/**
 * 更新用户订阅（管理员强制变更）
 */
export const adminBillingServiceUpdateUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateUserSubscriptionData, ThrowOnError>) => (options.client ?? client).put<AdminBillingServiceUpdateUserSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/admin/billing/users/{userId}/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get concurrency trend data
 */
export const adminDrivenStatsServiceGetConcurrencyTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetConcurrencyTrendData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetConcurrencyTrendResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/concurrency-trend', ...options });

/**
 * Get detailed stats for a specific entity (region, app, or user)
 */
export const adminDrivenStatsServiceGetEntityStats = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenStatsServiceGetEntityStatsData, ThrowOnError>) => (options.client ?? client).get<AdminDrivenStatsServiceGetEntityStatsResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/entity/{entityType}/{entityId}', ...options });

/**
 * Get overview statistics (top stat cards)
 */
export const adminDrivenStatsServiceGetOverview = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetOverviewData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetOverviewResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/overview', ...options });

/**
 * Get real-time stats from driveningress service
 */
export const adminDrivenStatsServiceGetRealtimeStats = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRealtimeStatsData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetRealtimeStatsResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/realtime', ...options });

/**
 * Get region distribution data (for pie chart)
 */
export const adminDrivenStatsServiceGetRegionDistribution = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRegionDistributionData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetRegionDistributionResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/region-distribution', ...options });

/**
 * Get top apps by usage
 */
export const adminDrivenStatsServiceGetTopApps = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTopAppsData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetTopAppsResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/top-apps', ...options });

/**
 * Get top users by usage
 */
export const adminDrivenStatsServiceGetTopUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTopUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetTopUsersResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/top-users', ...options });

/**
 * Get usage trend data (time series)
 */
export const adminDrivenStatsServiceGetTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTrendData, ThrowOnError>) => (options?.client ?? client).get<AdminDrivenStatsServiceGetTrendResponses, unknown, ThrowOnError>({ url: '/v2/admin/driven-stats/trend', ...options });

/**
 * 列出所有公共Avatar，支持可选过滤
 */
export const adminPublicAvatarServiceAdminListPublicAvatars = <ThrowOnError extends boolean = false>(options?: Options<AdminPublicAvatarServiceAdminListPublicAvatarsData, ThrowOnError>) => (options?.client ?? client).get<AdminPublicAvatarServiceAdminListPublicAvatarsResponses, unknown, ThrowOnError>({ url: '/v2/admin/public-avatars', ...options });

/**
 * 创建新的公共Avatar
 */
export const adminPublicAvatarServiceAdminCreatePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminCreatePublicAvatarData, ThrowOnError>) => (options.client ?? client).post<AdminPublicAvatarServiceAdminCreatePublicAvatarResponses, unknown, ThrowOnError>({
    url: '/v2/admin/public-avatars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 删除公共Avatar
 */
export const adminPublicAvatarServiceAdminDeletePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminDeletePublicAvatarData, ThrowOnError>) => (options.client ?? client).delete<AdminPublicAvatarServiceAdminDeletePublicAvatarResponses, unknown, ThrowOnError>({ url: '/v2/admin/public-avatars/{id}', ...options });

/**
 * 更新现有的公共Avatar
 */
export const adminPublicAvatarServiceAdminUpdatePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminUpdatePublicAvatarData, ThrowOnError>) => (options.client ?? client).put<AdminPublicAvatarServiceAdminUpdatePublicAvatarResponses, unknown, ThrowOnError>({
    url: '/v2/admin/public-avatars/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取自动充值配置
 */
export const billingServiceGetAutoReloadConfig = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetAutoReloadConfigData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceGetAutoReloadConfigResponses, unknown, ThrowOnError>({ url: '/v2/billing/auto-reload', ...options });

/**
 * 更新自动充值配置
 */
export const billingServiceUpdateAutoReloadConfig = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpdateAutoReloadConfigData, ThrowOnError>) => (options.client ?? client).put<BillingServiceUpdateAutoReloadConfigResponses, unknown, ThrowOnError>({
    url: '/v2/billing/auto-reload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 设置自动充值支付方式（返回 Stripe SetupIntent client_secret）
 */
export const billingServiceSetupAutoReloadPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<BillingServiceSetupAutoReloadPaymentMethodData, ThrowOnError>) => (options.client ?? client).post<BillingServiceSetupAutoReloadPaymentMethodResponses, unknown, ThrowOnError>({
    url: '/v2/billing/auto-reload/setup-payment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取可用充值包列表
 */
export const billingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditPackagesData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({ url: '/v2/billing/credit-packages', ...options });

/**
 * 手动购买充值包（返回 Stripe Checkout URL）
 */
export const billingServicePurchaseCreditPackage = <ThrowOnError extends boolean = false>(options: Options<BillingServicePurchaseCreditPackageData, ThrowOnError>) => (options.client ?? client).post<BillingServicePurchaseCreditPackageResponses, unknown, ThrowOnError>({
    url: '/v2/billing/credit-packages/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取 Credits 余额
 */
export const billingServiceGetCreditBalance = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetCreditBalanceData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceGetCreditBalanceResponses, unknown, ThrowOnError>({ url: '/v2/billing/credits', ...options });

/**
 * 获取 Credits 交易记录
 */
export const billingServiceListCreditTransactions = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditTransactionsData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceListCreditTransactionsResponses, unknown, ThrowOnError>({ url: '/v2/billing/credits/transactions', ...options });

/**
 * 获取 Stripe 客户门户链接
 */
export const billingServiceGetCustomerPortal = <ThrowOnError extends boolean = false>(options: Options<BillingServiceGetCustomerPortalData, ThrowOnError>) => (options.client ?? client).post<BillingServiceGetCustomerPortalResponses, unknown, ThrowOnError>({
    url: '/v2/billing/customer-portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取可用订阅计划列表
 */
export const billingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListPlansData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceListPlansResponses, unknown, ThrowOnError>({ url: '/v2/billing/plans', ...options });

/**
 * 检查是否可以开启新 Session
 */
export const billingServiceCheckSessionPermission = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCheckSessionPermissionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceCheckSessionPermissionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/session/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取当前用户的订阅信息
 */
export const billingServiceGetSubscription = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetSubscriptionData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceGetSubscriptionResponses, unknown, ThrowOnError>({ url: '/v2/billing/subscription', ...options });

/**
 * 创建新订阅（返回 Stripe Checkout URL）
 */
export const billingServiceCreateSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCreateSubscriptionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceCreateSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 取消订阅
 */
export const billingServiceCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCancelSubscriptionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceCancelSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/subscription/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 降级订阅计划（下个周期生效）
 */
export const billingServiceDowngradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceDowngradeSubscriptionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceDowngradeSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/subscription/downgrade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 恢复已取消的订阅
 */
export const billingServiceResumeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceResumeSubscriptionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceResumeSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/subscription/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 升级订阅计划
 */
export const billingServiceUpgradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpgradeSubscriptionData, ThrowOnError>) => (options.client ?? client).post<BillingServiceUpgradeSubscriptionResponses, unknown, ThrowOnError>({
    url: '/v2/billing/subscription/upgrade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取使用摘要
 */
export const billingServiceGetUsageSummary = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetUsageSummaryData, ThrowOnError>) => (options?.client ?? client).get<BillingServiceGetUsageSummaryResponses, unknown, ThrowOnError>({ url: '/v2/billing/usage', ...options });

export const drivenIngressServiceGetCharacterInfo = <ThrowOnError extends boolean = false>(options: Options<DrivenIngressServiceGetCharacterInfoData, ThrowOnError>) => (options.client ?? client).get<DrivenIngressServiceGetCharacterInfoResponses, unknown, ThrowOnError>({ url: '/v2/character/{characterId}', ...options });

/**
 * AI 素材调整（不写表，只做计算处理）
 */
export const asyncProcessingServiceAdjustMaterialAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceAdjustMaterialAsyncData, ThrowOnError>) => (options.client ?? client).post<AsyncProcessingServiceAdjustMaterialAsyncResponses, unknown, ThrowOnError>({
    url: '/v2/console/async-processing/adjust-material',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 创建异步任务（视频生成或重建任务，不写表，只做计算处理）
 */
export const asyncProcessingServiceCreateTaskAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceCreateTaskAsyncData, ThrowOnError>) => (options.client ?? client).post<AsyncProcessingServiceCreateTaskAsyncResponses, unknown, ThrowOnError>({
    url: '/v2/console/async-processing/create-task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列表Avatar申请
 */
export const avatarServiceListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarAppliesData, ThrowOnError>) => (options?.client ?? client).get<AvatarServiceListAvatarAppliesResponses, unknown, ThrowOnError>({ url: '/v2/console/avatar-applies', ...options });

/**
 * 删除Avatar申请
 */
export const avatarServiceDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarApplyData, ThrowOnError>) => (options.client ?? client).delete<AvatarServiceDeleteAvatarApplyResponses, unknown, ThrowOnError>({ url: '/v2/console/avatar-applies/{applyId}', ...options });

/**
 * 接收 Realtime 的回调
 */
export const avatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallback = <ThrowOnError extends boolean = false>(options: Options<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, ThrowOnError>) => (options.client ?? client).post<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, unknown, ThrowOnError>({
    url: '/v2/console/avatar-generate-task/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列出角色
 */
export const avatarServiceListAvatars = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarsData, ThrowOnError>) => (options?.client ?? client).get<AvatarServiceListAvatarsResponses, unknown, ThrowOnError>({ url: '/v2/console/avatars', ...options });

/**
 * 申请创建角色
 */
export const avatarServiceCreateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateAvatarData, ThrowOnError>) => (options.client ?? client).post<AvatarServiceCreateAvatarResponses, unknown, ThrowOnError>({
    url: '/v2/console/avatars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 删除角色
 */
export const avatarServiceDeleteAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarData, ThrowOnError>) => (options.client ?? client).delete<AvatarServiceDeleteAvatarResponses, unknown, ThrowOnError>({ url: '/v2/console/avatars/{id}', ...options });

/**
 * 获取角色详情
 */
export const avatarServiceGetAvatarDetail = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarDetailData, ThrowOnError>) => (options.client ?? client).get<AvatarServiceGetAvatarDetailResponses, unknown, ThrowOnError>({ url: '/v2/console/avatars/{id}', ...options });

/**
 * 编辑角色
 */
export const avatarServiceUpdateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceUpdateAvatarData, ThrowOnError>) => (options.client ?? client).patch<AvatarServiceUpdateAvatarResponses, unknown, ThrowOnError>({
    url: '/v2/console/avatars/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 复制角色
 */
export const avatarServiceCopyAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCopyAvatarData, ThrowOnError>) => (options.client ?? client).post<AvatarServiceCopyAvatarResponses, unknown, ThrowOnError>({
    url: '/v2/console/avatars/{id}/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 列表 DPT 驱动 Provider
 */
export const avatarServiceListDrivenProviders = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListDrivenProvidersData, ThrowOnError>) => (options?.client ?? client).get<AvatarServiceListDrivenProvidersResponses, unknown, ThrowOnError>({ url: '/v2/console/driven-providers', ...options });

/**
 * 列出 kling 驱动视频
 */
export const avatarServiceListKlingMotionPresets = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListKlingMotionPresetsData, ThrowOnError>) => (options?.client ?? client).get<AvatarServiceListKlingMotionPresetsResponses, unknown, ThrowOnError>({ url: '/v2/console/kling-motion-presets', ...options });

/**
 * 列出所有公共Avatar
 */
export const publicAvatarServiceListPublicAvatars = <ThrowOnError extends boolean = false>(options?: Options<PublicAvatarServiceListPublicAvatarsData, ThrowOnError>) => (options?.client ?? client).get<PublicAvatarServiceListPublicAvatarsResponses, unknown, ThrowOnError>({ url: '/v2/console/public-avatars', ...options });

/**
 * 获取 R2 上传预签名 URL（用于上传文件）
 */
export const commonServiceGetR2PresignedPutUrl = <ThrowOnError extends boolean = false>(options: Options<CommonServiceGetR2PresignedPutUrlData, ThrowOnError>) => (options.client ?? client).post<CommonServiceGetR2PresignedPutUrlResponses, unknown, ThrowOnError>({
    url: '/v2/console/r2-presigned-put-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reconModelServiceListReconModels = <ThrowOnError extends boolean = false>(options?: Options<ReconModelServiceListReconModelsData, ThrowOnError>) => (options?.client ?? client).get<ReconModelServiceListReconModelsResponses, unknown, ThrowOnError>({ url: '/v2/recon/models', ...options });

export const reconModelServiceCreateReconModel = <ThrowOnError extends boolean = false>(options: Options<ReconModelServiceCreateReconModelData, ThrowOnError>) => (options.client ?? client).post<ReconModelServiceCreateReconModelResponses, unknown, ThrowOnError>({
    url: '/v2/recon/models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reconModelServiceDeleteReconModel = <ThrowOnError extends boolean = false>(options: Options<ReconModelServiceDeleteReconModelData, ThrowOnError>) => (options.client ?? client).delete<ReconModelServiceDeleteReconModelResponses, unknown, ThrowOnError>({ url: '/v2/recon/models/{version}', ...options });

export const reconModelServiceGetReconModel = <ThrowOnError extends boolean = false>(options: Options<ReconModelServiceGetReconModelData, ThrowOnError>) => (options.client ?? client).get<ReconModelServiceGetReconModelResponses, unknown, ThrowOnError>({ url: '/v2/recon/models/{version}', ...options });

export const reconModelServiceUpdateReconModel = <ThrowOnError extends boolean = false>(options: Options<ReconModelServiceUpdateReconModelData, ThrowOnError>) => (options.client ?? client).put<ReconModelServiceUpdateReconModelResponses, unknown, ThrowOnError>({
    url: '/v2/recon/models/{version}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reconTaskServiceListReconTasks = <ThrowOnError extends boolean = false>(options?: Options<ReconTaskServiceListReconTasksData, ThrowOnError>) => (options?.client ?? client).get<ReconTaskServiceListReconTasksResponses, unknown, ThrowOnError>({ url: '/v2/recon/tasks', ...options });

export const reconTaskServiceCreateReconTask = <ThrowOnError extends boolean = false>(options: Options<ReconTaskServiceCreateReconTaskData, ThrowOnError>) => (options.client ?? client).post<ReconTaskServiceCreateReconTaskResponses, unknown, ThrowOnError>({
    url: '/v2/recon/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reconTaskServiceGetReconTask = <ThrowOnError extends boolean = false>(options: Options<ReconTaskServiceGetReconTaskData, ThrowOnError>) => (options.client ?? client).get<ReconTaskServiceGetReconTaskResponses, unknown, ThrowOnError>({ url: '/v2/recon/tasks/{id}', ...options });

export const reconTaskServiceCancelReconTask = <ThrowOnError extends boolean = false>(options: Options<ReconTaskServiceCancelReconTaskData, ThrowOnError>) => (options.client ?? client).post<ReconTaskServiceCancelReconTaskResponses, unknown, ThrowOnError>({
    url: '/v2/recon/tasks/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reconTaskServiceRetryReconTask = <ThrowOnError extends boolean = false>(options: Options<ReconTaskServiceRetryReconTaskData, ThrowOnError>) => (options.client ?? client).post<ReconTaskServiceRetryReconTaskResponses, unknown, ThrowOnError>({
    url: '/v2/recon/tasks/{id}/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
